// Automatically generated on 2019-01-19T00:07:08+02:00
// DO NOT EDIT or your changes may be overwritten

/* jshint maxstatements:2147483647  */
/* jshint esnext:true  */

import * as XDR from 'js-xdr';


var types = XDR.config(xdr => {

// === xdr source ============================================================
//
//   enum ErrorCode
//   {
//       ERR_MISC = 0, // Unspecific error
//       ERR_DATA = 1, // Malformed data
//       ERR_CONF = 2, // Misconfiguration error
//       ERR_AUTH = 3, // Authentication failure
//       ERR_LOAD = 4  // System overloaded
//   };
//
// ===========================================================================
xdr.enum("ErrorCode", {
  errMisc: 0,
  errDatum: 1,
  errConf: 2,
  errAuth: 3,
  errLoad: 4,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("ErrorExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Error
//   {
//       ErrorCode code;
//       string msg<100>;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("Error", [
  ["code", xdr.lookup("ErrorCode")],
  ["msg", xdr.string(100)],
  ["ext", xdr.lookup("ErrorExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("AuthCertExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct AuthCert
//   {
//       Curve25519Public pubkey;
//       uint64 expiration;
//       Signature sig;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("AuthCert", [
  ["pubkey", xdr.lookup("Curve25519Public")],
  ["expiration", xdr.lookup("Uint64")],
  ["sig", xdr.lookup("Signature")],
  ["ext", xdr.lookup("AuthCertExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("HelloExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Hello
//   {
//       uint32 ledgerVersion;
//       uint32 overlayVersion;
//       uint32 overlayMinVersion;
//       Hash networkID;
//       string versionStr<100>;
//       int listeningPort;
//       NodeID peerID;
//       AuthCert cert;
//       uint256 nonce;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("Hello", [
  ["ledgerVersion", xdr.lookup("Uint32")],
  ["overlayVersion", xdr.lookup("Uint32")],
  ["overlayMinVersion", xdr.lookup("Uint32")],
  ["networkId", xdr.lookup("Hash")],
  ["versionStr", xdr.string(100)],
  ["listeningPort", xdr.int()],
  ["peerId", xdr.lookup("NodeId")],
  ["cert", xdr.lookup("AuthCert")],
  ["nonce", xdr.lookup("Uint256")],
  ["ext", xdr.lookup("HelloExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("AuthExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Auth
//   {
//       // Empty message, just to confirm
//       // establishment of MAC keys.
//       int unused;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("Auth", [
  ["unused", xdr.int()],
  ["ext", xdr.lookup("AuthExt")],
]);

// === xdr source ============================================================
//
//   enum IPAddrType
//   {
//       IPv4 = 0,
//       IPv6 = 1
//   };
//
// ===========================================================================
xdr.enum("IpAddrType", {
  iPv4: 0,
  iPv6: 1,
});

// === xdr source ============================================================
//
//   union switch (IPAddrType type)
//       {
//       case IPv4:
//           opaque ipv4[4];
//       case IPv6:
//           opaque ipv6[16];
//       }
//
// ===========================================================================
xdr.union("PeerAddressIp", {
  switchOn: xdr.lookup("IpAddrType"),
  switchName: "type",
  switches: [
    ["iPv4", "ipv4"],
    ["iPv6", "ipv6"],
  ],
  arms: {
    ipv4: xdr.opaque(4),
    ipv6: xdr.opaque(16),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("PeerAddressExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct PeerAddress
//   {
//       union switch (IPAddrType type)
//       {
//       case IPv4:
//           opaque ipv4[4];
//       case IPv6:
//           opaque ipv6[16];
//       }
//       ip;
//       uint32 port;
//       uint32 numFailures;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("PeerAddress", [
  ["ip", xdr.lookup("PeerAddressIp")],
  ["port", xdr.lookup("Uint32")],
  ["numFailures", xdr.lookup("Uint32")],
  ["ext", xdr.lookup("PeerAddressExt")],
]);

// === xdr source ============================================================
//
//   enum MessageType
//   {
//       ERROR_MSG = 0,
//       AUTH = 2,
//       DONT_HAVE = 3,
//   
//       GET_PEERS = 4, // gets a list of peers this guy knows about
//       PEERS = 5,
//   
//       GET_TX_SET = 6, // gets a particular txset by hash
//       TX_SET = 7,
//   
//       TRANSACTION = 8, // pass on a tx you have heard about
//   
//       // SCP
//       GET_SCP_QUORUMSET = 9,
//       SCP_QUORUMSET = 10,
//       SCP_MESSAGE = 11,
//       GET_SCP_STATE = 12,
//   
//       // new messages
//       HELLO = 13
//   };
//
// ===========================================================================
xdr.enum("MessageType", {
  errorMsg: 0,
  auth: 2,
  dontHave: 3,
  getPeer: 4,
  peer: 5,
  getTxSet: 6,
  txSet: 7,
  transaction: 8,
  getScpQuorumset: 9,
  scpQuorumset: 10,
  scpMessage: 11,
  getScpState: 12,
  hello: 13,
});

// === xdr source ============================================================
//
//   struct DontHave
//   {
//       MessageType type;
//       uint256 reqHash;
//   };
//
// ===========================================================================
xdr.struct("DontHave", [
  ["type", xdr.lookup("MessageType")],
  ["reqHash", xdr.lookup("Uint256")],
]);

// === xdr source ============================================================
//
//   union StellarMessage switch (MessageType type)
//   {
//   case ERROR_MSG:
//       Error error;
//   case HELLO:
//       Hello hello;
//   case AUTH:
//       Auth auth;
//   case DONT_HAVE:
//       DontHave dontHave;
//   case GET_PEERS:
//       void;
//   case PEERS:
//       PeerAddress peers<>;
//   
//   case GET_TX_SET:
//       uint256 txSetHash;
//   case TX_SET:
//       TransactionSet txSet;
//   
//   case TRANSACTION:
//       TransactionEnvelope transaction;
//   
//   // SCP
//   case GET_SCP_QUORUMSET:
//       uint256 qSetHash;
//   case SCP_QUORUMSET:
//       SCPQuorumSet qSet;
//   case SCP_MESSAGE:
//       SCPEnvelope envelope;
//   case GET_SCP_STATE:
//       uint32 getSCPLedgerSeq; // ledger seq requested ; if 0, requests the latest
//   };
//
// ===========================================================================
xdr.union("StellarMessage", {
  switchOn: xdr.lookup("MessageType"),
  switchName: "type",
  switches: [
    ["errorMsg", "error"],
    ["hello", "hello"],
    ["auth", "auth"],
    ["dontHave", "dontHave"],
    ["getPeer", xdr.void()],
    ["peer", "peers"],
    ["getTxSet", "txSetHash"],
    ["txSet", "txSet"],
    ["transaction", "transaction"],
    ["getScpQuorumset", "qSetHash"],
    ["scpQuorumset", "qSet"],
    ["scpMessage", "envelope"],
    ["getScpState", "getScpLedgerSeq"],
  ],
  arms: {
    error: xdr.lookup("Error"),
    hello: xdr.lookup("Hello"),
    auth: xdr.lookup("Auth"),
    dontHave: xdr.lookup("DontHave"),
    peers: xdr.varArray(xdr.lookup("PeerAddress"), 2147483647),
    txSetHash: xdr.lookup("Uint256"),
    txSet: xdr.lookup("TransactionSet"),
    transaction: xdr.lookup("TransactionEnvelope"),
    qSetHash: xdr.lookup("Uint256"),
    qSet: xdr.lookup("ScpQuorumSet"),
    envelope: xdr.lookup("ScpEnvelope"),
    getScpLedgerSeq: xdr.lookup("Uint32"),
  },
});

// === xdr source ============================================================
//
//   struct
//   {
//      uint64 sequence;
//      StellarMessage message;
//      HmacSha256Mac mac;
//       }
//
// ===========================================================================
xdr.struct("AuthenticatedMessageV0", [
  ["sequence", xdr.lookup("Uint64")],
  ["message", xdr.lookup("StellarMessage")],
  ["mac", xdr.lookup("HmacSha256Mac")],
]);

// === xdr source ============================================================
//
//   union AuthenticatedMessage switch (LedgerVersion v)
//   {
//   case EMPTY_VERSION:
//       struct
//   {
//      uint64 sequence;
//      StellarMessage message;
//      HmacSha256Mac mac;
//       } v0;
//   };
//
// ===========================================================================
xdr.union("AuthenticatedMessage", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", "v0"],
  ],
  arms: {
    v0: xdr.lookup("AuthenticatedMessageV0"),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("BidRequestExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct BidRequest
//   {
//       uint64 lotID;
//       uint64 amount;      // amount to pay
//       bool isBuyNow;      // buy now request
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       } ext;
//   };
//
// ===========================================================================
xdr.struct("BidRequest", [
  ["lotId", xdr.lookup("Uint64")],
  ["amount", xdr.lookup("Uint64")],
  ["isBuyNow", xdr.bool()],
  ["ext", xdr.lookup("BidRequestExt")],
]);

// === xdr source ============================================================
//
//   enum MigrationVersion {
//           MIGRATION_ACCOUNT_TYPE = 1,
//           MIGRATION_ADD_PLATFORM_ID_TO_ACCOUNT = 2
//       };
//
// ===========================================================================
xdr.enum("MigrationVersion", {
  migrationAccountType: 1,
  migrationAddPlatformIdToAccount: 2,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//                   case EMPTY_VERSION:
//                       void;
//               }
//
// ===========================================================================
xdr.union("MigrationEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct MigrationEntry {
//           MigrationVersion migrationVersion;
//   
//           union switch (LedgerVersion v)
//               {
//                   case EMPTY_VERSION:
//                       void;
//               }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("MigrationEntry", [
  ["migrationVersion", xdr.lookup("MigrationVersion")],
  ["ext", xdr.lookup("MigrationEntryExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CreateLotOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreateLotOp
//       {
//           uint64 requestID;       // 0 to create new, otherwise update existing
//   
//           LotType lotType;
//           bool buyNowSupport;     // does lot support buy now
//   
//           string details<>;       // JSON string with full lot description
//   
//           string currency<3>;     // currency of start price and buy now price
//           uint64 startPrice;      // all prices are indicated in cents
//           uint64 deposit;         // minimal deposit to pay for participating
//           uint64 buyNowPrice;
//           uint64 minStep;
//           uint64 maxStep;
//   
//           int64 startTime;        // auction start time in Unix epoch format
//           uint64 duration;        // duration in seconds (optional for certain type of lot)
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CreateLotOp", [
  ["requestId", xdr.lookup("Uint64")],
  ["lotType", xdr.lookup("LotType")],
  ["buyNowSupport", xdr.bool()],
  ["details", xdr.string()],
  ["currency", xdr.string(3)],
  ["startPrice", xdr.lookup("Uint64")],
  ["deposit", xdr.lookup("Uint64")],
  ["buyNowPrice", xdr.lookup("Uint64")],
  ["minStep", xdr.lookup("Uint64")],
  ["maxStep", xdr.lookup("Uint64")],
  ["startTime", xdr.lookup("Int64")],
  ["duration", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("CreateLotOpExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CreateLotSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreateLotSuccess {
//           uint64 requestID;
//           uint64 lotID;
//           bool fulfilled;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CreateLotSuccess", [
  ["requestId", xdr.lookup("Uint64")],
  ["lotId", xdr.lookup("Uint64")],
  ["fulfilled", xdr.bool()],
  ["ext", xdr.lookup("CreateLotSuccessExt")],
]);

// === xdr source ============================================================
//
//   enum CreateLotResultCode
//       {
//           CREATE_LOT_SUCCESS = 0, // lot was created
//   
//           CREATE_LOT_ALREADY_EXIST = -1,              // for future use
//           CREATE_LOT_MALFORMED = -2,
//           CREATE_LOT_MALFORMED_START_TIME = -3,       // attempt to create lot in past
//           CREATE_LOT_TOO_LOW_MIN_STEP = -4,           // should be >= 1
//           CREATE_LOT_TOO_LOW_MAX_STEP = -5,           // should be > min step
//           CREATE_LOT_INVALID_JSON = -6,
//           CREATE_LOT_MALFORMED_CURRENCY = -7,
//           CREATE_LOT_MALFORMED_PRICE = -8,            // should be buyNow > startPrice (if supported)
//           CREATE_LOT_INVALID_VERSION = -9,
//           CREATE_LOT_REQUEST_NOT_FOUND = -10,
//           CREATE_LOT_REFERENCE_DUPLICATION = -11,
//           CREATE_LOT_LOT_TYPE_NOT_ALLOWED = -12,      // source is not allowed to create lots of this type
//           CREATE_LOT_NO_AUCTION_MALFORMED = -13,      // lot must support buy now and have zero start price and steps
//           CREATE_LOT_COPART_MALFORMED = -14           // copart lots must have zero steps and duration
//       };
//
// ===========================================================================
xdr.enum("CreateLotResultCode", {
  createLotSuccess: 0,
  createLotAlreadyExist: -1,
  createLotMalformed: -2,
  createLotMalformedStartTime: -3,
  createLotTooLowMinStep: -4,
  createLotTooLowMaxStep: -5,
  createLotInvalidJson: -6,
  createLotMalformedCurrency: -7,
  createLotMalformedPrice: -8,
  createLotInvalidVersion: -9,
  createLotRequestNotFound: -10,
  createLotReferenceDuplication: -11,
  createLotLotTypeNotAllowed: -12,
  createLotNoAuctionMalformed: -13,
  createLotCopartMalformed: -14,
});

// === xdr source ============================================================
//
//   union CreateLotResult switch (CreateLotResultCode code)
//       {
//       case CREATE_LOT_SUCCESS:
//           CreateLotSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("CreateLotResult", {
  switchOn: xdr.lookup("CreateLotResultCode"),
  switchName: "code",
  switches: [
    ["createLotSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("CreateLotSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//           void;
//           }
//
// ===========================================================================
xdr.union("MessageEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct MessageEntry
//       {
//           uint64 messageID;
//   
//           AccountID senderID;
//           AccountID receiverID;
//           uint64 lotID;
//   
//           string text<1000>;
//   
//           int64 createdAt;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//           void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("MessageEntry", [
  ["messageId", xdr.lookup("Uint64")],
  ["senderId", xdr.lookup("AccountId")],
  ["receiverId", xdr.lookup("AccountId")],
  ["lotId", xdr.lookup("Uint64")],
  ["text", xdr.string(1000)],
  ["createdAt", xdr.lookup("Int64")],
  ["ext", xdr.lookup("MessageEntryExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("SendMessageOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct SendMessageOp
//       {
//           AccountID receiverID;
//           uint64 lotID;
//   
//           string text<1000>;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("SendMessageOp", [
  ["receiverId", xdr.lookup("AccountId")],
  ["lotId", xdr.lookup("Uint64")],
  ["text", xdr.string(1000)],
  ["ext", xdr.lookup("SendMessageOpExt")],
]);

// === xdr source ============================================================
//
//   enum SendMessageResultCode
//       {
//           SEND_MESSAGE_SUCCESS = 0,
//           SEND_MESSAGE_NO_LOT = -1,           // lot with lotID not found
//           SEND_MESSAGE_NO_RECEIVER = -2,      // receiver not found or not the participant/organizer of the lot
//           SEND_MESSAGE_MALFORMED = -3         // empty message
//       };
//
// ===========================================================================
xdr.enum("SendMessageResultCode", {
  sendMessageSuccess: 0,
  sendMessageNoLot: -1,
  sendMessageNoReceiver: -2,
  sendMessageMalformed: -3,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//
// ===========================================================================
xdr.union("SendMessageResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                       uint64 messageID;
//                       
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     }
//
// ===========================================================================
xdr.struct("SendMessageResultSuccess", [
  ["messageId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("SendMessageResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union SendMessageResult switch (SendMessageResultCode code)
//       {
//       case SEND_MESSAGE_SUCCESS:
//           struct {
//                       uint64 messageID;
//                       
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("SendMessageResult", {
  switchOn: xdr.lookup("SendMessageResultCode"),
  switchName: "code",
  switches: [
    ["sendMessageSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("SendMessageResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("RequestParticipationOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RequestParticipationOp
//       {
//           uint64 lotID;
//           bool isBuyNow; // if set, buy now will be automatically requested
//   
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RequestParticipationOp", [
  ["lotId", xdr.lookup("Uint64")],
  ["isBuyNow", xdr.bool()],
  ["ext", xdr.lookup("RequestParticipationOpExt")],
]);

// === xdr source ============================================================
//
//   enum RequestParticipationResultCode
//       {
//           REQUEST_PARTICIPATION_SUCCESS = 0,
//           REQUEST_PARTICIPATION_NO_LOT = -1,
//           REQUEST_PARTICIPATION_ALREADY_REQUESTED = -2,
//           REQUEST_PARTICIPATION_ALREADY_PARTICIPANT = -3,
//           REQUEST_PARTICIPATION_TOO_LATE = -4,
//           REQUEST_PARTICIPATION_MALFORMED = -5,
//           REQUEST_PARTICIPATION_INVALID_VERSION = -6,
//           REQUEST_PARTICIPATION_OWNER_CANT_PARTICIPATE = -7,      // owner is not allowed to participate
//           REQUEST_PARTICIPATION_NO_BUY_NOW = -8,                  // attempt to request buy now on lot that doesn't support it
//           REQUEST_PARTICIPATION_BUY_NOW_ALREADY_TAKEN = -9        // buy now for shelf auction is already taken
//       };
//
// ===========================================================================
xdr.enum("RequestParticipationResultCode", {
  requestParticipationSuccess: 0,
  requestParticipationNoLot: -1,
  requestParticipationAlreadyRequested: -2,
  requestParticipationAlreadyParticipant: -3,
  requestParticipationTooLate: -4,
  requestParticipationMalformed: -5,
  requestParticipationInvalidVersion: -6,
  requestParticipationOwnerCantParticipate: -7,
  requestParticipationNoBuyNow: -8,
  requestParticipationBuyNowAlreadyTaken: -9,
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("RequestParticipationSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RequestParticipationSuccess
//       {
//           uint64 requestID;
//           bool fulfilled;
//   
//           // reserved for future use
//           union switch(LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RequestParticipationSuccess", [
  ["requestId", xdr.lookup("Uint64")],
  ["fulfilled", xdr.bool()],
  ["ext", xdr.lookup("RequestParticipationSuccessExt")],
]);

// === xdr source ============================================================
//
//   union RequestParticipationResult switch (RequestParticipationResultCode code)
//       {
//       case REQUEST_PARTICIPATION_SUCCESS:
//           RequestParticipationSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("RequestParticipationResult", {
  switchOn: xdr.lookup("RequestParticipationResultCode"),
  switchName: "code",
  switches: [
    ["requestParticipationSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("RequestParticipationSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("ManageOfferOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ManageOfferOp
//       {
//           Asset selling;
//           Asset buying;
//           int64 amount; // amount being sold. if set to 0, delete the offer
//           Price price;  // price of thing being sold in terms of what you are buying
//   
//           // 0=create a new offer, otherwise edit an existing offer
//           uint64 offerID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("ManageOfferOp", [
  ["selling", xdr.lookup("Asset")],
  ["buying", xdr.lookup("Asset")],
  ["amount", xdr.lookup("Int64")],
  ["price", xdr.lookup("Price")],
  ["offerId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("ManageOfferOpExt")],
]);

// === xdr source ============================================================
//
//   enum ManageOfferResultCode
//       {
//           // codes considered as "success" for the operation
//           MANAGE_OFFER_SUCCESS = 0,
//   
//           // codes considered as "failure" for the operation
//           MANAGE_OFFER_MALFORMED = -1,     // generated offer would be invalid
//           MANAGE_OFFER_SELL_NO_TRUST = -2, // no trust line for what we're selling
//           MANAGE_OFFER_BUY_NO_TRUST = -3,  // no trust line for what we're buying
//           MANAGE_OFFER_SELL_NOT_AUTHORIZED = -4, // not authorized to sell
//           MANAGE_OFFER_BUY_NOT_AUTHORIZED = -5,  // not authorized to buy
//           MANAGE_OFFER_LINE_FULL = -6,      // can't receive more of what it's buying
//           MANAGE_OFFER_UNDERFUNDED = -7,    // doesn't hold what it's trying to sell
//           MANAGE_OFFER_CROSS_SELF = -8,     // would cross an offer from the same user
//           MANAGE_OFFER_SELL_NO_ISSUER = -9, // no issuer for what we're selling
//           MANAGE_OFFER_BUY_NO_ISSUER = -10, // no issuer for what we're buying
//   
//           // update errors
//           MANAGE_OFFER_NOT_FOUND = -11, // offerID does not match an existing offer
//   
//           MANAGE_OFFER_LOW_RESERVE = -12 // not enough funds to create a new Offer
//       };
//
// ===========================================================================
xdr.enum("ManageOfferResultCode", {
  manageOfferSuccess: 0,
  manageOfferMalformed: -1,
  manageOfferSellNoTrust: -2,
  manageOfferBuyNoTrust: -3,
  manageOfferSellNotAuthorized: -4,
  manageOfferBuyNotAuthorized: -5,
  manageOfferLineFull: -6,
  manageOfferUnderfunded: -7,
  manageOfferCrossSelf: -8,
  manageOfferSellNoIssuer: -9,
  manageOfferBuyNoIssuer: -10,
  manageOfferNotFound: -11,
  manageOfferLowReserve: -12,
});

// === xdr source ============================================================
//
//   enum ManageOfferEffect
//       {
//           MANAGE_OFFER_CREATED = 0,
//           MANAGE_OFFER_UPDATED = 1,
//           MANAGE_OFFER_DELETED = 2
//       };
//
// ===========================================================================
xdr.enum("ManageOfferEffect", {
  manageOfferCreated: 0,
  manageOfferUpdated: 1,
  manageOfferDeleted: 2,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("ClaimOfferAtomExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ClaimOfferAtom
//       {
//           // emitted to identify the offer
//           AccountID sellerID; // Account that owns the offer
//           uint64 offerID;
//   
//           // amount and asset taken from the owner
//           Asset assetSold;
//           int64 amountSold;
//   
//           // amount and asset sent to the owner
//           Asset assetBought;
//           int64 amountBought;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("ClaimOfferAtom", [
  ["sellerId", xdr.lookup("AccountId")],
  ["offerId", xdr.lookup("Uint64")],
  ["assetSold", xdr.lookup("Asset")],
  ["amountSold", xdr.lookup("Int64")],
  ["assetBought", xdr.lookup("Asset")],
  ["amountBought", xdr.lookup("Int64")],
  ["ext", xdr.lookup("ClaimOfferAtomExt")],
]);

// === xdr source ============================================================
//
//   union switch (ManageOfferEffect effect)
//           {
//           case MANAGE_OFFER_CREATED:
//           case MANAGE_OFFER_UPDATED:
//               OfferEntry offer;
//           default:
//               void;
//           }
//
// ===========================================================================
xdr.union("ManageOfferSuccessResultOffer", {
  switchOn: xdr.lookup("ManageOfferEffect"),
  switchName: "effect",
  switches: [
    ["manageOfferCreated", "offer"],
    ["manageOfferUpdated", "offer"],
  ],
  arms: {
    offer: xdr.lookup("OfferEntry"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("ManageOfferSuccessResultExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ManageOfferSuccessResult
//       {
//           // offers that got claimed while creating this offer
//           ClaimOfferAtom offersClaimed<>;
//   
//           union switch (ManageOfferEffect effect)
//           {
//           case MANAGE_OFFER_CREATED:
//           case MANAGE_OFFER_UPDATED:
//               OfferEntry offer;
//           default:
//               void;
//           }
//           offer;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("ManageOfferSuccessResult", [
  ["offersClaimed", xdr.varArray(xdr.lookup("ClaimOfferAtom"), 2147483647)],
  ["offer", xdr.lookup("ManageOfferSuccessResultOffer")],
  ["ext", xdr.lookup("ManageOfferSuccessResultExt")],
]);

// === xdr source ============================================================
//
//   union ManageOfferResult switch (ManageOfferResultCode code)
//       {
//       case MANAGE_OFFER_SUCCESS:
//           ManageOfferSuccessResult success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("ManageOfferResult", {
  switchOn: xdr.lookup("ManageOfferResultCode"),
  switchName: "code",
  switches: [
    ["manageOfferSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("ManageOfferSuccessResult"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("SetOptionsOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct SetOptionsOp
//       {
//           AccountID* inflationDest; // sets the inflation destination
//   
//           uint32* clearFlags; // which flags to clear
//           uint32* setFlags;   // which flags to set
//   
//           // account threshold manipulation
//           uint32* masterWeight; // weight of the master account
//           uint32* lowThreshold;
//           uint32* medThreshold;
//           uint32* highThreshold;
//   
//           string32* homeDomain; // sets the home domain
//   
//           // Add, update or remove a signer for the account
//           // signer is deleted if the weight is 0
//           Signer* signer;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("SetOptionsOp", [
  ["inflationDest", xdr.option(xdr.lookup("AccountId"))],
  ["clearFlags", xdr.option(xdr.lookup("Uint32"))],
  ["setFlags", xdr.option(xdr.lookup("Uint32"))],
  ["masterWeight", xdr.option(xdr.lookup("Uint32"))],
  ["lowThreshold", xdr.option(xdr.lookup("Uint32"))],
  ["medThreshold", xdr.option(xdr.lookup("Uint32"))],
  ["highThreshold", xdr.option(xdr.lookup("Uint32"))],
  ["homeDomain", xdr.option(xdr.lookup("String32"))],
  ["signer", xdr.option(xdr.lookup("Signer"))],
  ["ext", xdr.lookup("SetOptionsOpExt")],
]);

// === xdr source ============================================================
//
//   enum SetOptionsResultCode
//       {
//           // codes considered as "success" for the operation
//           SET_OPTIONS_SUCCESS = 0,
//           // codes considered as "failure" for the operation
//           SET_OPTIONS_LOW_RESERVE = -1,      // not enough funds to add a signer
//           SET_OPTIONS_TOO_MANY_SIGNERS = -2, // max number of signers already reached
//           SET_OPTIONS_BAD_FLAGS = -3,        // invalid combination of clear/set flags
//           SET_OPTIONS_INVALID_INFLATION = -4,      // inflation account does not exist
//           SET_OPTIONS_CANT_CHANGE = -5,            // can no longer change this option
//           SET_OPTIONS_UNKNOWN_FLAG = -6,           // can't set an unknown flag
//           SET_OPTIONS_THRESHOLD_OUT_OF_RANGE = -7, // bad value for weight/threshold
//           SET_OPTIONS_BAD_SIGNER = -8,             // signer cannot be masterkey
//           SET_OPTIONS_INVALID_HOME_DOMAIN = -9     // malformed home domain
//       };
//
// ===========================================================================
xdr.enum("SetOptionsResultCode", {
  setOptionsSuccess: 0,
  setOptionsLowReserve: -1,
  setOptionsTooManySigner: -2,
  setOptionsBadFlag: -3,
  setOptionsInvalidInflation: -4,
  setOptionsCantChange: -5,
  setOptionsUnknownFlag: -6,
  setOptionsThresholdOutOfRange: -7,
  setOptionsBadSigner: -8,
  setOptionsInvalidHomeDomain: -9,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//
// ===========================================================================
xdr.union("SetOptionsResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     }
//
// ===========================================================================
xdr.struct("SetOptionsResultSuccess", [
  ["ext", xdr.lookup("SetOptionsResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union SetOptionsResult switch (SetOptionsResultCode code)
//       {
//       case SET_OPTIONS_SUCCESS:
//           struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("SetOptionsResult", {
  switchOn: xdr.lookup("SetOptionsResultCode"),
  switchName: "code",
  switches: [
    ["setOptionsSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("SetOptionsResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("SignerExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Signer
//       {
//           AccountID pubKey;
//           uint32 weight; // really only need 1byte
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("Signer", [
  ["pubKey", xdr.lookup("AccountId")],
  ["weight", xdr.lookup("Uint32")],
  ["ext", xdr.lookup("SignerExt")],
]);

// === xdr source ============================================================
//
//   enum AccountFlags
//       {   // masks for each flag
//   
//           // Flags set on issuer accounts
//           // TrustLines are created with authorized set to "false" requiring
//           // the issuer to set it for each TrustLine
//           AUTH_REQUIRED_FLAG = 0x1,
//           // If set, the authorized flag in TrustLines can be cleared
//           // otherwise, authorization cannot be revoked
//           AUTH_REVOCABLE_FLAG = 0x2,
//           // Once set, causes all AUTH_* flags to be read-only
//           AUTH_IMMUTABLE_FLAG = 0x4
//       };
//
// ===========================================================================
xdr.enum("AccountFlags", {
  authRequiredFlag: 1,
  authRevocableFlag: 2,
  authImmutableFlag: 4,
});

// === xdr source ============================================================
//
//   enum AccountType
//       {
//           ACCOUNT_TYPE_MASTER = 1,
//           ACCOUNT_TYPE_PLATFORM = 2,
//           ACCOUNT_TYPE_DEALER = 3,
//           ACCOUNT_TYPE_USER = 4,
//           ACCOUNT_TYPE_ADMIN = 5
//       };
//
// ===========================================================================
xdr.enum("AccountType", {
  accountTypeMaster: 1,
  accountTypePlatform: 2,
  accountTypeDealer: 3,
  accountTypeUser: 4,
  accountTypeAdmin: 5,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("AccountEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct AccountEntry
//       {
//           AccountID accountID;
//           AccountType accountType;
//   
//           AccountID platformID; // accountId of the platform this account belongs to
//   
//           // fields used for signatures
//           // thresholds stores unsigned bytes: [weight of master|low|medium|high]
//           Thresholds thresholds;
//   
//           Signer signers<20>; // possible signers for this account
//   
//           // deprecated:
//           int64 balance;
//           uint32 flags;
//           uint32 numSubEntries;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("AccountEntry", [
  ["accountId", xdr.lookup("AccountId")],
  ["accountType", xdr.lookup("AccountType")],
  ["platformId", xdr.lookup("AccountId")],
  ["thresholds", xdr.lookup("Thresholds")],
  ["signers", xdr.varArray(xdr.lookup("Signer"), 20)],
  ["balance", xdr.lookup("Int64")],
  ["flags", xdr.lookup("Uint32")],
  ["numSubEntries", xdr.lookup("Uint32")],
  ["ext", xdr.lookup("AccountEntryExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("ParticipationRequestExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ParticipationRequest
//   {
//       uint64 lotID;
//       bool isBuyNow;
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("ParticipationRequest", [
  ["lotId", xdr.lookup("Uint64")],
  ["isBuyNow", xdr.bool()],
  ["ext", xdr.lookup("ParticipationRequestExt")],
]);

// === xdr source ============================================================
//
//   typedef opaque Hash[32];
//
// ===========================================================================
xdr.typedef("Hash", xdr.opaque(32));

// === xdr source ============================================================
//
//   typedef opaque uint256[32];
//
// ===========================================================================
xdr.typedef("Uint256", xdr.opaque(32));

// === xdr source ============================================================
//
//   typedef unsigned int uint32;
//
// ===========================================================================
xdr.typedef("Uint32", xdr.uint());

// === xdr source ============================================================
//
//   typedef int int32;
//
// ===========================================================================
xdr.typedef("Int32", xdr.int());

// === xdr source ============================================================
//
//   typedef unsigned hyper uint64;
//
// ===========================================================================
xdr.typedef("Uint64", xdr.uhyper());

// === xdr source ============================================================
//
//   typedef hyper int64;
//
// ===========================================================================
xdr.typedef("Int64", xdr.hyper());

// === xdr source ============================================================
//
//   enum CryptoKeyType
//   {
//       KEY_TYPE_ED25519 = 0
//   };
//
// ===========================================================================
xdr.enum("CryptoKeyType", {
  keyTypeEd25519: 0,
});

// === xdr source ============================================================
//
//   union PublicKey switch (CryptoKeyType type)
//   {
//   case KEY_TYPE_ED25519:
//       uint256 ed25519;
//   };
//
// ===========================================================================
xdr.union("PublicKey", {
  switchOn: xdr.lookup("CryptoKeyType"),
  switchName: "type",
  switches: [
    ["keyTypeEd25519", "ed25519"],
  ],
  arms: {
    ed25519: xdr.lookup("Uint256"),
  },
});

// === xdr source ============================================================
//
//   typedef opaque Signature<64>;
//
// ===========================================================================
xdr.typedef("Signature", xdr.varOpaque(64));

// === xdr source ============================================================
//
//   typedef opaque SignatureHint[4];
//
// ===========================================================================
xdr.typedef("SignatureHint", xdr.opaque(4));

// === xdr source ============================================================
//
//   typedef PublicKey NodeID;
//
// ===========================================================================
xdr.typedef("NodeId", xdr.lookup("PublicKey"));

// === xdr source ============================================================
//
//   struct Curve25519Secret
//   {
//           opaque key[32];
//   };
//
// ===========================================================================
xdr.struct("Curve25519Secret", [
  ["key", xdr.opaque(32)],
]);

// === xdr source ============================================================
//
//   struct Curve25519Public
//   {
//           opaque key[32];
//   };
//
// ===========================================================================
xdr.struct("Curve25519Public", [
  ["key", xdr.opaque(32)],
]);

// === xdr source ============================================================
//
//   struct HmacSha256Key
//   {
//           opaque key[32];
//   };
//
// ===========================================================================
xdr.struct("HmacSha256Key", [
  ["key", xdr.opaque(32)],
]);

// === xdr source ============================================================
//
//   struct HmacSha256Mac
//   {
//           opaque mac[32];
//   };
//
// ===========================================================================
xdr.struct("HmacSha256Mac", [
  ["mac", xdr.opaque(32)],
]);

// === xdr source ============================================================
//
//   typedef PublicKey AccountID;
//
// ===========================================================================
xdr.typedef("AccountId", xdr.lookup("PublicKey"));

// === xdr source ============================================================
//
//   typedef opaque Thresholds[4];
//
// ===========================================================================
xdr.typedef("Thresholds", xdr.opaque(4));

// === xdr source ============================================================
//
//   typedef string string32<32>;
//
// ===========================================================================
xdr.typedef("String32", xdr.string(32));

// === xdr source ============================================================
//
//   typedef string string64<64>;
//
// ===========================================================================
xdr.typedef("String64", xdr.string(64));

// === xdr source ============================================================
//
//   typedef string string256<256>;
//
// ===========================================================================
xdr.typedef("String256", xdr.string(256));

// === xdr source ============================================================
//
//   typedef uint64 Salt;
//
// ===========================================================================
xdr.typedef("Salt", xdr.lookup("Uint64"));

// === xdr source ============================================================
//
//   typedef uint64 SequenceNumber;
//
// ===========================================================================
xdr.typedef("SequenceNumber", xdr.lookup("Uint64"));

// === xdr source ============================================================
//
//   struct DecoratedSignature
//       {
//           SignatureHint hint;  // last 4 bytes of the public key, used as a hint
//           Signature signature; // actual signature
//       };
//
// ===========================================================================
xdr.struct("DecoratedSignature", [
  ["hint", xdr.lookup("SignatureHint")],
  ["signature", xdr.lookup("Signature")],
]);

// === xdr source ============================================================
//
//   enum LedgerVersion {
//           EMPTY_VERSION = 0,
//           LEDGER_VERSION_SIGN_BY_PLATFORM = 1
//       };
//
// ===========================================================================
xdr.enum("LedgerVersion", {
  emptyVersion: 0,
  ledgerVersionSignByPlatform: 1,
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("LotCreationRequestExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LotCreationRequest
//   {
//       LotEntry lot;
//   
//       // reserved for future use
//       union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       } ext;
//   };
//
// ===========================================================================
xdr.struct("LotCreationRequest", [
  ["lot", xdr.lookup("LotEntry")],
  ["ext", xdr.lookup("LotCreationRequestExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("ManageMigrationOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ManageMigrationOp {
//           MigrationVersion migrationVersion;
//   
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("ManageMigrationOp", [
  ["migrationVersion", xdr.lookup("MigrationVersion")],
  ["ext", xdr.lookup("ManageMigrationOpExt")],
]);

// === xdr source ============================================================
//
//   enum ManageMigrationResultCode
//       {
//           MANAGE_MIGRATION_SUCCESS = 0, // lot was created
//           MANAGE_MIGRATION_NOT_ROOT = -1,
//           MANAGE_MIGRATION_MALFORMED = -2,
//           MANAGE_MIGRATION_ALREADY_MIGRATE = -3,
//           MANAGE_MIGRATION_INVALID_MIGRATE_VERSION = -4,
//           MANAGE_MIGRATION_FAILED = -5
//       };
//
// ===========================================================================
xdr.enum("ManageMigrationResultCode", {
  manageMigrationSuccess: 0,
  manageMigrationNotRoot: -1,
  manageMigrationMalformed: -2,
  manageMigrationAlreadyMigrate: -3,
  manageMigrationInvalidMigrateVersion: -4,
  manageMigrationFailed: -5,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                   {
//                   case EMPTY_VERSION:
//                     void;
//                   }
//
// ===========================================================================
xdr.union("ManageMigrationResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                   // reserved for future use
//                   union switch (LedgerVersion v)
//                   {
//                   case EMPTY_VERSION:
//                     void;
//                   }
//                   ext;
//                 }
//
// ===========================================================================
xdr.struct("ManageMigrationResultSuccess", [
  ["ext", xdr.lookup("ManageMigrationResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union ManageMigrationResult switch (ManageMigrationResultCode code)
//       {
//       case MANAGE_MIGRATION_SUCCESS :
//           struct {
//                   // reserved for future use
//                   union switch (LedgerVersion v)
//                   {
//                   case EMPTY_VERSION:
//                     void;
//                   }
//                   ext;
//                 } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("ManageMigrationResult", {
  switchOn: xdr.lookup("ManageMigrationResultCode"),
  switchName: "code",
  switches: [
    ["manageMigrationSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("ManageMigrationResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("RequestBuyNowOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RequestBuyNowOp
//       {
//           uint64 lotID;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RequestBuyNowOp", [
  ["lotId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("RequestBuyNowOpExt")],
]);

// === xdr source ============================================================
//
//   enum RequestBuyNowResultCode
//       {
//           REQUEST_BUY_NOW_SUCCESS = 0,
//           REQUEST_BUY_NOW_LOT_NOT_FOUND = -1,
//           REQUEST_BUY_NOW_UNSUPPORTED = -2,       // lot doesn't support buy now
//           REQUEST_BUY_NOW_UNREGISTERED = -3,      // register to lot first, before submitting buy now
//           REQUEST_BUY_NOW_TOO_LATE = -4,          // auction is not active
//           REQUEST_BUY_NOW_ALREADY_REQUESTED = -5, // source already requested buy now
//           REQUEST_BUY_NOW_ALREADY_TAKEN = -6      // buy now has already been requested by another participant
//       };
//
// ===========================================================================
xdr.enum("RequestBuyNowResultCode", {
  requestBuyNowSuccess: 0,
  requestBuyNowLotNotFound: -1,
  requestBuyNowUnsupported: -2,
  requestBuyNowUnregistered: -3,
  requestBuyNowTooLate: -4,
  requestBuyNowAlreadyRequested: -5,
  requestBuyNowAlreadyTaken: -6,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//                 void;
//           }
//
// ===========================================================================
xdr.union("RequestBuyNowSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RequestBuyNowSuccess
//       {
//           uint64 requestID;
//           bool fulfilled;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//                 void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RequestBuyNowSuccess", [
  ["requestId", xdr.lookup("Uint64")],
  ["fulfilled", xdr.bool()],
  ["ext", xdr.lookup("RequestBuyNowSuccessExt")],
]);

// === xdr source ============================================================
//
//   union RequestBuyNowResult switch (RequestBuyNowResultCode code)
//       {
//       case REQUEST_BUY_NOW_SUCCESS:
//           RequestBuyNowSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("RequestBuyNowResult", {
  switchOn: xdr.lookup("RequestBuyNowResultCode"),
  switchName: "code",
  switches: [
    ["requestBuyNowSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("RequestBuyNowSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("CancelRequestOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CancelRequestOp
//       {
//           uint64 requestID;
//   
//           union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           } ext;
//       };
//
// ===========================================================================
xdr.struct("CancelRequestOp", [
  ["requestId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("CancelRequestOpExt")],
]);

// === xdr source ============================================================
//
//   enum CancelRequestResultCode
//       {
//           CANCEL_REQUEST_SUCCESS = 0,
//   
//           CANCEL_REQUEST_NOT_FOUND = -1, // request not found
//           CANCEL_REQUEST_NOT_ALLOWED = -2, // only requestor can cancel his request
//           CANCEL_REQUEST_TYPE_NOT_ALLOWED = -3 // can't cancel this type of request
//       };
//
// ===========================================================================
xdr.enum("CancelRequestResultCode", {
  cancelRequestSuccess: 0,
  cancelRequestNotFound: -1,
  cancelRequestNotAllowed: -2,
  cancelRequestTypeNotAllowed: -3,
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("CancelRequestSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CancelRequestSuccess
//       {
//   
//           // reserved for future use
//           union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           } ext;
//       };
//
// ===========================================================================
xdr.struct("CancelRequestSuccess", [
  ["ext", xdr.lookup("CancelRequestSuccessExt")],
]);

// === xdr source ============================================================
//
//   union CancelRequestResult switch (CancelRequestResultCode code)
//       {
//           case CANCEL_REQUEST_SUCCESS:
//               CancelRequestSuccess success;
//           default:
//               void;
//       };
//
// ===========================================================================
xdr.union("CancelRequestResult", {
  switchOn: xdr.lookup("CancelRequestResultCode"),
  switchName: "code",
  switches: [
    ["cancelRequestSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("CancelRequestSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   enum TrustLineFlags
//       {
//           // issuer has authorized account to perform transactions with its credit
//           AUTHORIZED_FLAG = 1
//       };
//
// ===========================================================================
xdr.enum("TrustLineFlags", {
  authorizedFlag: 1,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TrustLineEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TrustLineEntry
//       {
//           AccountID accountID; // account this trustline belongs to
//           Asset asset;         // type of asset (with issuer)
//           int64 balance;       // how much of this asset the user has.
//                                // Asset defines the unit for this;
//   
//           int64 limit;  // balance cannot be above this
//           uint32 flags; // see TrustLineFlags
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("TrustLineEntry", [
  ["accountId", xdr.lookup("AccountId")],
  ["asset", xdr.lookup("Asset")],
  ["balance", xdr.lookup("Int64")],
  ["limit", xdr.lookup("Int64")],
  ["flags", xdr.lookup("Uint32")],
  ["ext", xdr.lookup("TrustLineEntryExt")],
]);

// === xdr source ============================================================
//
//   enum ManageParticipantAction
//       {
//           MANAGE_PARTICIPANT_ACTION_CHOOSE_WINNER = 0,
//           MANAGE_PARTICIPANT_ACTION_REJECT = 1,
//           MANAGE_PARTICIPANT_ACTION_APPROVE_BUY_NOW = 2
//       };
//
// ===========================================================================
xdr.enum("ManageParticipantAction", {
  manageParticipantActionChooseWinner: 0,
  manageParticipantActionReject: 1,
  manageParticipantActionApproveBuyNow: 2,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("ManageParticipantOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ManageParticipantOp
//       {
//           ManageParticipantAction action;
//   
//           uint64 lotID;
//           AccountID accountID;
//   
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("ManageParticipantOp", [
  ["action", xdr.lookup("ManageParticipantAction")],
  ["lotId", xdr.lookup("Uint64")],
  ["accountId", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("ManageParticipantOpExt")],
]);

// === xdr source ============================================================
//
//   enum ManageParticipantResultCode
//       {
//           MANAGE_PARTICIPANT_SUCCESS = 0,
//   
//           MANAGE_PARTICIPANT_BIDDER_NOT_FOUND = -1,
//           MANAGE_PARTICIPANT_TOO_EARLY = -2,                 // auction hasn't started or currently active (not for buy now)
//           MANAGE_PARTICIPANT_AUCTION_CLOSED = -3,            // auction is closed
//           MANAGE_PARTICIPANT_ALREADY_HAS_WINNER = -4,        // lot has participant with state winner or buy now winner
//           MANAGE_PARTICIPANT_ALREADY_REJECTED = -5,          // lot has participant with state winner or buy now winner
//           MANAGE_PARTICIPANT_BAD_CHOICE = -6,                // lot has better bidders, reject them first
//           MANAGE_PARTICIPANT_NOT_ALLOWED = -7                // only platform can resolve auction
//       };
//
// ===========================================================================
xdr.enum("ManageParticipantResultCode", {
  manageParticipantSuccess: 0,
  manageParticipantBidderNotFound: -1,
  manageParticipantTooEarly: -2,
  manageParticipantAuctionClosed: -3,
  manageParticipantAlreadyHasWinner: -4,
  manageParticipantAlreadyRejected: -5,
  manageParticipantBadChoice: -6,
  manageParticipantNotAllowed: -7,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("ManageParticipantSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ManageParticipantSuccess
//       {
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("ManageParticipantSuccess", [
  ["ext", xdr.lookup("ManageParticipantSuccessExt")],
]);

// === xdr source ============================================================
//
//   union ManageParticipantResult switch (ManageParticipantResultCode code)
//       {
//       case MANAGE_PARTICIPANT_SUCCESS:
//           ManageParticipantSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("ManageParticipantResult", {
  switchOn: xdr.lookup("ManageParticipantResultCode"),
  switchName: "code",
  switches: [
    ["manageParticipantSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("ManageParticipantSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CreateBidOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreateBidOp
//       {
//           uint64 lotID;
//           uint64 amount;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CreateBidOp", [
  ["lotId", xdr.lookup("Uint64")],
  ["amount", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("CreateBidOpExt")],
]);

// === xdr source ============================================================
//
//   enum CreateBidResultCode
//       {
//           CREATE_BID_SUCCESS = 0,
//           CREATE_BID_NO_LOT = -1,
//           CREATE_BID_NO_PARTICIPANT = -2,
//           CREATE_BID_TOO_EARLY = -3,
//           CREATE_BID_TOO_LATE = -4,
//           CREATE_BID_LESS_THAN_START_PRICE = -5,
//           CREATE_BID_LESS_THAN_PREV_BID = -6,
//           CREATE_BID_INVALID_STEP = -7,
//           CREATE_BID_MALFORMED = -8,
//           CREATE_BID_NO_AUCTION = -9,                 // can't bid on no-auction lot type
//           CREATE_BID_NOT_ALLOWED = -10,               // participant is not in pending state
//           CREATE_BID_COPART_ALREADY_HAS_BID = -15,
//           CREATE_BID_COPART_ALREADY_REQUESTED = -16,
//           CREATE_BID_COPART_NOT_ALLOWED = -17
//       };
//
// ===========================================================================
xdr.enum("CreateBidResultCode", {
  createBidSuccess: 0,
  createBidNoLot: -1,
  createBidNoParticipant: -2,
  createBidTooEarly: -3,
  createBidTooLate: -4,
  createBidLessThanStartPrice: -5,
  createBidLessThanPrevBid: -6,
  createBidInvalidStep: -7,
  createBidMalformed: -8,
  createBidNoAuction: -9,
  createBidNotAllowed: -10,
  createBidCopartAlreadyHasBid: -15,
  createBidCopartAlreadyRequested: -16,
  createBidCopartNotAllowed: -17,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CreateBidSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreateBidSuccess
//       {
//           bool fulfilled;
//           uint64 requestID;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CreateBidSuccess", [
  ["fulfilled", xdr.bool()],
  ["requestId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("CreateBidSuccessExt")],
]);

// === xdr source ============================================================
//
//   union CreateBidResult switch (CreateBidResultCode code)
//       {
//       case CREATE_BID_SUCCESS:
//          CreateBidSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("CreateBidResult", {
  switchOn: xdr.lookup("CreateBidResultCode"),
  switchName: "code",
  switches: [
    ["createBidSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("CreateBidSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("ChangeTrustOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ChangeTrustOp
//       {
//           Asset line;
//   
//           // if limit is set to 0, deletes the trust line
//           int64 limit;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("ChangeTrustOp", [
  ["line", xdr.lookup("Asset")],
  ["limit", xdr.lookup("Int64")],
  ["ext", xdr.lookup("ChangeTrustOpExt")],
]);

// === xdr source ============================================================
//
//   enum ChangeTrustResultCode
//       {
//           // codes considered as "success" for the operation
//           CHANGE_TRUST_SUCCESS = 0,
//           // codes considered as "failure" for the operation
//           CHANGE_TRUST_MALFORMED = -1,     // bad input
//           CHANGE_TRUST_NO_ISSUER = -2,     // could not find issuer
//           CHANGE_TRUST_INVALID_LIMIT = -3, // cannot drop limit below balance
//                                            // cannot create with a limit of 0
//           CHANGE_TRUST_LOW_RESERVE = -4 // not enough funds to create a new trust line
//       };
//
// ===========================================================================
xdr.enum("ChangeTrustResultCode", {
  changeTrustSuccess: 0,
  changeTrustMalformed: -1,
  changeTrustNoIssuer: -2,
  changeTrustInvalidLimit: -3,
  changeTrustLowReserve: -4,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//
// ===========================================================================
xdr.union("ChangeTrustResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     }
//
// ===========================================================================
xdr.struct("ChangeTrustResultSuccess", [
  ["ext", xdr.lookup("ChangeTrustResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union ChangeTrustResult switch (ChangeTrustResultCode code)
//       {
//       case CHANGE_TRUST_SUCCESS:
//           struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("ChangeTrustResult", {
  switchOn: xdr.lookup("ChangeTrustResultCode"),
  switchName: "code",
  switches: [
    ["changeTrustSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("ChangeTrustResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (AssetType type)
//           {
//           // ASSET_TYPE_NATIVE is not allowed
//           case ASSET_TYPE_CREDIT_ALPHANUM4:
//               opaque assetCode4[4];
//   
//           case ASSET_TYPE_CREDIT_ALPHANUM12:
//               opaque assetCode12[12];
//   
//               // add other asset types here in the future
//           }
//
// ===========================================================================
xdr.union("AllowTrustOpAsset", {
  switchOn: xdr.lookup("AssetType"),
  switchName: "type",
  switches: [
    ["assetTypeCreditAlphanum4", "assetCode4"],
    ["assetTypeCreditAlphanum12", "assetCode12"],
  ],
  arms: {
    assetCode4: xdr.opaque(4),
    assetCode12: xdr.opaque(12),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("AllowTrustOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct AllowTrustOp
//       {
//           AccountID trustor;
//           union switch (AssetType type)
//           {
//           // ASSET_TYPE_NATIVE is not allowed
//           case ASSET_TYPE_CREDIT_ALPHANUM4:
//               opaque assetCode4[4];
//   
//           case ASSET_TYPE_CREDIT_ALPHANUM12:
//               opaque assetCode12[12];
//   
//               // add other asset types here in the future
//           }
//           asset;
//   
//           bool authorize;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("AllowTrustOp", [
  ["trustor", xdr.lookup("AccountId")],
  ["asset", xdr.lookup("AllowTrustOpAsset")],
  ["authorize", xdr.bool()],
  ["ext", xdr.lookup("AllowTrustOpExt")],
]);

// === xdr source ============================================================
//
//   enum AllowTrustResultCode
//       {
//           // codes considered as "success" for the operation
//           ALLOW_TRUST_SUCCESS = 0,
//           // codes considered as "failure" for the operation
//           ALLOW_TRUST_MALFORMED = -1,     // asset is not ASSET_TYPE_ALPHANUM
//           ALLOW_TRUST_NO_TRUST_LINE = -2, // trustor does not have a trustline
//                                           // source account does not require trust
//           ALLOW_TRUST_TRUST_NOT_REQUIRED = -3,
//           ALLOW_TRUST_CANT_REVOKE = -4 // source account can't revoke trust
//       };
//
// ===========================================================================
xdr.enum("AllowTrustResultCode", {
  allowTrustSuccess: 0,
  allowTrustMalformed: -1,
  allowTrustNoTrustLine: -2,
  allowTrustTrustNotRequired: -3,
  allowTrustCantRevoke: -4,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//
// ===========================================================================
xdr.union("AllowTrustResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     }
//
// ===========================================================================
xdr.struct("AllowTrustResultSuccess", [
  ["ext", xdr.lookup("AllowTrustResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union AllowTrustResult switch (AllowTrustResultCode code)
//       {
//       case ALLOW_TRUST_SUCCESS:
//           struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("AllowTrustResult", {
  switchOn: xdr.lookup("AllowTrustResultCode"),
  switchName: "code",
  switches: [
    ["allowTrustSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("AllowTrustResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("ReferenceEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ReferenceEntry
//   {
//   	AccountID sender;
//       string64 reference;
//   
//   	// reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("ReferenceEntry", [
  ["sender", xdr.lookup("AccountId")],
  ["reference", xdr.lookup("String64")],
  ["ext", xdr.lookup("ReferenceEntryExt")],
]);

// === xdr source ============================================================
//
//   enum OperationType
//       {
//           CREATE_ACCOUNT = 0,
//           PAYMENT = 1,
//           PATH_PAYMENT = 2,
//           MANAGE_OFFER = 3,
//           CREATE_PASSIVE_OFFER = 4,
//           SET_OPTIONS = 5,
//           CHANGE_TRUST = 6,
//           ALLOW_TRUST = 7,
//           CREATE_LOT = 8,
//           REQUEST_PARTICIPATION = 9,
//           SEND_MESSAGE = 10,
//           CREATE_BID = 11,
//           RECOVER = 12,
//           MANAGE_MIGRATION = 13,
//           REVIEW_REQUEST = 14,
//           CANCEL_REQUEST = 15,
//           MANAGE_PARTICIPANT = 16,
//           REQUEST_BUY_NOW = 17,
//           CLOSE_AUCTION = 18,
//           UPDATE_LOT = 19
//       };
//
// ===========================================================================
xdr.enum("OperationType", {
  createAccount: 0,
  payment: 1,
  pathPayment: 2,
  manageOffer: 3,
  createPassiveOffer: 4,
  setOption: 5,
  changeTrust: 6,
  allowTrust: 7,
  createLot: 8,
  requestParticipation: 9,
  sendMessage: 10,
  createBid: 11,
  recover: 12,
  manageMigration: 13,
  reviewRequest: 14,
  cancelRequest: 15,
  manageParticipant: 16,
  requestBuyNow: 17,
  closeAuction: 18,
  updateLot: 19,
});

// === xdr source ============================================================
//
//   union switch (OperationType type)
//           {
//           case CREATE_ACCOUNT:
//               CreateAccountOp createAccountOp;
//           case PAYMENT:
//               PaymentOp paymentOp;
//           case PATH_PAYMENT:
//               PathPaymentOp pathPaymentOp;
//           case MANAGE_OFFER:
//               ManageOfferOp manageOfferOp;
//           case CREATE_PASSIVE_OFFER:
//               CreatePassiveOfferOp createPassiveOfferOp;
//           case SET_OPTIONS:
//               SetOptionsOp setOptionsOp;
//           case CHANGE_TRUST:
//               ChangeTrustOp changeTrustOp;
//           case ALLOW_TRUST:
//               AllowTrustOp allowTrustOp;
//           case CREATE_LOT:
//               CreateLotOp createLotOp;
//           case UPDATE_LOT:
//               UpdateLotOp updateLotOp;
//           case REQUEST_PARTICIPATION:
//               RequestParticipationOp requestParticipationOp;
//           case SEND_MESSAGE:
//               SendMessageOp sendMessageOp;
//           case CREATE_BID:
//               CreateBidOp createBidOp;
//           case RECOVER:
//               RecoverOp recoverOp;
//           case MANAGE_MIGRATION:
//               ManageMigrationOp manageMigrationOp;
//           case REVIEW_REQUEST:
//               ReviewRequestOp reviewRequestOp;
//           case CANCEL_REQUEST:
//               CancelRequestOp cancelRequestOp;
//           case MANAGE_PARTICIPANT:
//               ManageParticipantOp manageParticipantOp;
//           case CLOSE_AUCTION:
//               CloseAuctionOp closeAuctionOp;
//           case REQUEST_BUY_NOW:
//               RequestBuyNowOp requestBuyNowOp;
//           }
//
// ===========================================================================
xdr.union("OperationBody", {
  switchOn: xdr.lookup("OperationType"),
  switchName: "type",
  switches: [
    ["createAccount", "createAccountOp"],
    ["payment", "paymentOp"],
    ["pathPayment", "pathPaymentOp"],
    ["manageOffer", "manageOfferOp"],
    ["createPassiveOffer", "createPassiveOfferOp"],
    ["setOption", "setOptionsOp"],
    ["changeTrust", "changeTrustOp"],
    ["allowTrust", "allowTrustOp"],
    ["createLot", "createLotOp"],
    ["updateLot", "updateLotOp"],
    ["requestParticipation", "requestParticipationOp"],
    ["sendMessage", "sendMessageOp"],
    ["createBid", "createBidOp"],
    ["recover", "recoverOp"],
    ["manageMigration", "manageMigrationOp"],
    ["reviewRequest", "reviewRequestOp"],
    ["cancelRequest", "cancelRequestOp"],
    ["manageParticipant", "manageParticipantOp"],
    ["closeAuction", "closeAuctionOp"],
    ["requestBuyNow", "requestBuyNowOp"],
  ],
  arms: {
    createAccountOp: xdr.lookup("CreateAccountOp"),
    paymentOp: xdr.lookup("PaymentOp"),
    pathPaymentOp: xdr.lookup("PathPaymentOp"),
    manageOfferOp: xdr.lookup("ManageOfferOp"),
    createPassiveOfferOp: xdr.lookup("CreatePassiveOfferOp"),
    setOptionsOp: xdr.lookup("SetOptionsOp"),
    changeTrustOp: xdr.lookup("ChangeTrustOp"),
    allowTrustOp: xdr.lookup("AllowTrustOp"),
    createLotOp: xdr.lookup("CreateLotOp"),
    updateLotOp: xdr.lookup("UpdateLotOp"),
    requestParticipationOp: xdr.lookup("RequestParticipationOp"),
    sendMessageOp: xdr.lookup("SendMessageOp"),
    createBidOp: xdr.lookup("CreateBidOp"),
    recoverOp: xdr.lookup("RecoverOp"),
    manageMigrationOp: xdr.lookup("ManageMigrationOp"),
    reviewRequestOp: xdr.lookup("ReviewRequestOp"),
    cancelRequestOp: xdr.lookup("CancelRequestOp"),
    manageParticipantOp: xdr.lookup("ManageParticipantOp"),
    closeAuctionOp: xdr.lookup("CloseAuctionOp"),
    requestBuyNowOp: xdr.lookup("RequestBuyNowOp"),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("OperationExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Operation
//       {
//           // sourceAccount is the account used to run the operation
//           // if not set, the runtime defaults to "sourceAccount" specified at
//           // the transaction level
//           AccountID* sourceAccount;
//   
//           union switch (OperationType type)
//           {
//           case CREATE_ACCOUNT:
//               CreateAccountOp createAccountOp;
//           case PAYMENT:
//               PaymentOp paymentOp;
//           case PATH_PAYMENT:
//               PathPaymentOp pathPaymentOp;
//           case MANAGE_OFFER:
//               ManageOfferOp manageOfferOp;
//           case CREATE_PASSIVE_OFFER:
//               CreatePassiveOfferOp createPassiveOfferOp;
//           case SET_OPTIONS:
//               SetOptionsOp setOptionsOp;
//           case CHANGE_TRUST:
//               ChangeTrustOp changeTrustOp;
//           case ALLOW_TRUST:
//               AllowTrustOp allowTrustOp;
//           case CREATE_LOT:
//               CreateLotOp createLotOp;
//           case UPDATE_LOT:
//               UpdateLotOp updateLotOp;
//           case REQUEST_PARTICIPATION:
//               RequestParticipationOp requestParticipationOp;
//           case SEND_MESSAGE:
//               SendMessageOp sendMessageOp;
//           case CREATE_BID:
//               CreateBidOp createBidOp;
//           case RECOVER:
//               RecoverOp recoverOp;
//           case MANAGE_MIGRATION:
//               ManageMigrationOp manageMigrationOp;
//           case REVIEW_REQUEST:
//               ReviewRequestOp reviewRequestOp;
//           case CANCEL_REQUEST:
//               CancelRequestOp cancelRequestOp;
//           case MANAGE_PARTICIPANT:
//               ManageParticipantOp manageParticipantOp;
//           case CLOSE_AUCTION:
//               CloseAuctionOp closeAuctionOp;
//           case REQUEST_BUY_NOW:
//               RequestBuyNowOp requestBuyNowOp;
//           }
//           body;
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("Operation", [
  ["sourceAccount", xdr.option(xdr.lookup("AccountId"))],
  ["body", xdr.lookup("OperationBody")],
  ["ext", xdr.lookup("OperationExt")],
]);

// === xdr source ============================================================
//
//   enum MemoType
//       {
//           MEMO_NONE = 0,
//           MEMO_TEXT = 1,
//           MEMO_ID = 2,
//           MEMO_HASH = 3,
//           MEMO_RETURN = 4,
//           MEMO_ADDITIONAL_SIGNATURE = 5
//       };
//
// ===========================================================================
xdr.enum("MemoType", {
  memoNone: 0,
  memoText: 1,
  memoId: 2,
  memoHash: 3,
  memoReturn: 4,
  memoAdditionalSignature: 5,
});

// === xdr source ============================================================
//
//   union Memo switch (MemoType type)
//       {
//       case MEMO_NONE:
//           void;
//       case MEMO_TEXT:
//           string text<28>;
//       case MEMO_ID:
//           uint64 id;
//       case MEMO_HASH:
//           Hash hash; // the hash of what to pull from the content server
//       case MEMO_RETURN:
//           Hash retHash; // the hash of the tx you are rejecting
//       case MEMO_ADDITIONAL_SIGNATURE:
//           string additionalSign<>;
//       };
//
// ===========================================================================
xdr.union("Memo", {
  switchOn: xdr.lookup("MemoType"),
  switchName: "type",
  switches: [
    ["memoNone", xdr.void()],
    ["memoText", "text"],
    ["memoId", "id"],
    ["memoHash", "hash"],
    ["memoReturn", "retHash"],
    ["memoAdditionalSignature", "additionalSign"],
  ],
  arms: {
    text: xdr.string(28),
    id: xdr.lookup("Uint64"),
    hash: xdr.lookup("Hash"),
    retHash: xdr.lookup("Hash"),
    additionalSign: xdr.string(),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("TimeBoundsExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TimeBounds
//       {
//           uint64 minTime;
//           uint64 maxTime;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("TimeBounds", [
  ["minTime", xdr.lookup("Uint64")],
  ["maxTime", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("TimeBoundsExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Transaction
//       {
//           // account used to run the transaction
//           AccountID sourceAccount;
//   
//           // the fee the sourceAccount will pay
//           uint32 fee;
//   
//           // transaction's salt
//           Salt salt;
//   
//           // validity range (inclusive) for the last ledger close time
//           TimeBounds* timeBounds;
//   
//           Memo memo;
//   
//           Operation operations<100>;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("Transaction", [
  ["sourceAccount", xdr.lookup("AccountId")],
  ["fee", xdr.lookup("Uint32")],
  ["salt", xdr.lookup("Salt")],
  ["timeBounds", xdr.option(xdr.lookup("TimeBounds"))],
  ["memo", xdr.lookup("Memo")],
  ["operations", xdr.varArray(xdr.lookup("Operation"), 100)],
  ["ext", xdr.lookup("TransactionExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("TransactionEnvelopeExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionEnvelope
//       {
//           Transaction tx;
//           DecoratedSignature signatures<20>;
//           Memo additionalSignatures<10>;
//           // reserved for future use
//               union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("TransactionEnvelope", [
  ["tx", xdr.lookup("Transaction")],
  ["signatures", xdr.varArray(xdr.lookup("DecoratedSignature"), 20)],
  ["additionalSignatures", xdr.varArray(xdr.lookup("Memo"), 10)],
  ["ext", xdr.lookup("TransactionEnvelopeExt")],
]);

// === xdr source ============================================================
//
//   enum OperationResultCode
//       {
//           opINNER = 0, // inner object result is valid
//   
//           opBAD_AUTH = -1,  // too few valid signatures / wrong network
//           opNO_ACCOUNT = -2, // source account was not found
//           opNOT_ALLOWED = -3 // account type is not allowed
//       };
//
// ===========================================================================
xdr.enum("OperationResultCode", {
  opInner: 0,
  opBadAuth: -1,
  opNoAccount: -2,
  opNotAllowed: -3,
});

// === xdr source ============================================================
//
//   union switch (OperationType type)
//           {
//           case CREATE_ACCOUNT:
//               CreateAccountResult createAccountResult;
//           case PAYMENT:
//               PaymentResult paymentResult;
//           case PATH_PAYMENT:
//               PathPaymentResult pathPaymentResult;
//           case MANAGE_OFFER:
//               ManageOfferResult manageOfferResult;
//           case CREATE_PASSIVE_OFFER:
//               ManageOfferResult createPassiveOfferResult;
//           case SET_OPTIONS:
//               SetOptionsResult setOptionsResult;
//           case CHANGE_TRUST:
//               ChangeTrustResult changeTrustResult;
//           case ALLOW_TRUST:
//               AllowTrustResult allowTrustResult;
//           case CREATE_LOT:
//               CreateLotResult createLotResult;
//           case UPDATE_LOT:
//               UpdateLotResult updateLotResult;
//           case REQUEST_PARTICIPATION:
//               RequestParticipationResult requestParticipationResult;
//           case SEND_MESSAGE:
//               SendMessageResult sendMessageResult;
//           case CREATE_BID:
//               CreateBidResult createBidResult;
//           case RECOVER:
//               RecoverResult recoverResult;
//           case MANAGE_MIGRATION:
//               ManageMigrationResult manageMigrationResult;
//           case REVIEW_REQUEST:
//               ReviewRequestResult reviewRequestResult;
//           case CANCEL_REQUEST:
//               CancelRequestResult cancelRequestResult;
//           case MANAGE_PARTICIPANT:
//               ManageParticipantResult manageParticipantResult;
//           case CLOSE_AUCTION:
//               CloseAuctionResult closeAuctionResult;
//           case REQUEST_BUY_NOW:
//               RequestBuyNowResult requestBuyNowResult;
//           }
//
// ===========================================================================
xdr.union("OperationResultTr", {
  switchOn: xdr.lookup("OperationType"),
  switchName: "type",
  switches: [
    ["createAccount", "createAccountResult"],
    ["payment", "paymentResult"],
    ["pathPayment", "pathPaymentResult"],
    ["manageOffer", "manageOfferResult"],
    ["createPassiveOffer", "createPassiveOfferResult"],
    ["setOption", "setOptionsResult"],
    ["changeTrust", "changeTrustResult"],
    ["allowTrust", "allowTrustResult"],
    ["createLot", "createLotResult"],
    ["updateLot", "updateLotResult"],
    ["requestParticipation", "requestParticipationResult"],
    ["sendMessage", "sendMessageResult"],
    ["createBid", "createBidResult"],
    ["recover", "recoverResult"],
    ["manageMigration", "manageMigrationResult"],
    ["reviewRequest", "reviewRequestResult"],
    ["cancelRequest", "cancelRequestResult"],
    ["manageParticipant", "manageParticipantResult"],
    ["closeAuction", "closeAuctionResult"],
    ["requestBuyNow", "requestBuyNowResult"],
  ],
  arms: {
    createAccountResult: xdr.lookup("CreateAccountResult"),
    paymentResult: xdr.lookup("PaymentResult"),
    pathPaymentResult: xdr.lookup("PathPaymentResult"),
    manageOfferResult: xdr.lookup("ManageOfferResult"),
    createPassiveOfferResult: xdr.lookup("ManageOfferResult"),
    setOptionsResult: xdr.lookup("SetOptionsResult"),
    changeTrustResult: xdr.lookup("ChangeTrustResult"),
    allowTrustResult: xdr.lookup("AllowTrustResult"),
    createLotResult: xdr.lookup("CreateLotResult"),
    updateLotResult: xdr.lookup("UpdateLotResult"),
    requestParticipationResult: xdr.lookup("RequestParticipationResult"),
    sendMessageResult: xdr.lookup("SendMessageResult"),
    createBidResult: xdr.lookup("CreateBidResult"),
    recoverResult: xdr.lookup("RecoverResult"),
    manageMigrationResult: xdr.lookup("ManageMigrationResult"),
    reviewRequestResult: xdr.lookup("ReviewRequestResult"),
    cancelRequestResult: xdr.lookup("CancelRequestResult"),
    manageParticipantResult: xdr.lookup("ManageParticipantResult"),
    closeAuctionResult: xdr.lookup("CloseAuctionResult"),
    requestBuyNowResult: xdr.lookup("RequestBuyNowResult"),
  },
});

// === xdr source ============================================================
//
//   union OperationResult switch (OperationResultCode code)
//       {
//       case opINNER:
//           union switch (OperationType type)
//           {
//           case CREATE_ACCOUNT:
//               CreateAccountResult createAccountResult;
//           case PAYMENT:
//               PaymentResult paymentResult;
//           case PATH_PAYMENT:
//               PathPaymentResult pathPaymentResult;
//           case MANAGE_OFFER:
//               ManageOfferResult manageOfferResult;
//           case CREATE_PASSIVE_OFFER:
//               ManageOfferResult createPassiveOfferResult;
//           case SET_OPTIONS:
//               SetOptionsResult setOptionsResult;
//           case CHANGE_TRUST:
//               ChangeTrustResult changeTrustResult;
//           case ALLOW_TRUST:
//               AllowTrustResult allowTrustResult;
//           case CREATE_LOT:
//               CreateLotResult createLotResult;
//           case UPDATE_LOT:
//               UpdateLotResult updateLotResult;
//           case REQUEST_PARTICIPATION:
//               RequestParticipationResult requestParticipationResult;
//           case SEND_MESSAGE:
//               SendMessageResult sendMessageResult;
//           case CREATE_BID:
//               CreateBidResult createBidResult;
//           case RECOVER:
//               RecoverResult recoverResult;
//           case MANAGE_MIGRATION:
//               ManageMigrationResult manageMigrationResult;
//           case REVIEW_REQUEST:
//               ReviewRequestResult reviewRequestResult;
//           case CANCEL_REQUEST:
//               CancelRequestResult cancelRequestResult;
//           case MANAGE_PARTICIPANT:
//               ManageParticipantResult manageParticipantResult;
//           case CLOSE_AUCTION:
//               CloseAuctionResult closeAuctionResult;
//           case REQUEST_BUY_NOW:
//               RequestBuyNowResult requestBuyNowResult;
//           }
//           tr;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("OperationResult", {
  switchOn: xdr.lookup("OperationResultCode"),
  switchName: "code",
  switches: [
    ["opInner", "tr"],
  ],
  arms: {
    tr: xdr.lookup("OperationResultTr"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   enum TransactionResultCode
//       {
//           txSUCCESS = 0, // all operations succeeded
//   
//           txFAILED = -1, // one of the operations failed (none were applied)
//   
//           txTOO_EARLY = -2,         // ledger closeTime before minTime
//           txTOO_LATE = -3,          // ledger closeTime after maxTime
//           txMISSING_OPERATION = -4, // no operation was specified
//   
//           txBAD_AUTH = -6,             // too few valid signatures / wrong network
//           txINSUFFICIENT_BALANCE = -7, // fee would bring account below reserve
//           txNO_ACCOUNT = -8,           // source account not found
//           txINSUFFICIENT_FEE = -9,     // fee is too small
//           txBAD_AUTH_EXTRA = -10,      // unused signatures attached to transaction
//           txINTERNAL_ERROR = -11       // an unknown error occured
//       };
//
// ===========================================================================
xdr.enum("TransactionResultCode", {
  txSuccess: 0,
  txFailed: -1,
  txTooEarly: -2,
  txTooLate: -3,
  txMissingOperation: -4,
  txBadAuth: -6,
  txInsufficientBalance: -7,
  txNoAccount: -8,
  txInsufficientFee: -9,
  txBadAuthExtra: -10,
  txInternalError: -11,
});

// === xdr source ============================================================
//
//   union switch (TransactionResultCode code)
//           {
//           case txSUCCESS:
//           case txFAILED:
//               OperationResult results<>;
//           default:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionResultResult", {
  switchOn: xdr.lookup("TransactionResultCode"),
  switchName: "code",
  switches: [
    ["txSuccess", "results"],
    ["txFailed", "results"],
  ],
  arms: {
    results: xdr.varArray(xdr.lookup("OperationResult"), 2147483647),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionResultExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionResult
//       {
//           int64 feeCharged; // actual fee charged for the transaction
//   
//           union switch (TransactionResultCode code)
//           {
//           case txSUCCESS:
//           case txFAILED:
//               OperationResult results<>;
//           default:
//               void;
//           }
//           result;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("TransactionResult", [
  ["feeCharged", xdr.lookup("Int64")],
  ["result", xdr.lookup("TransactionResultResult")],
  ["ext", xdr.lookup("TransactionResultExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("PaymentOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct PaymentOp
//       {
//           AccountID destination; // recipient of the payment
//           Asset asset;           // what they end up with
//           int64 amount;          // amount they end up with
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("PaymentOp", [
  ["destination", xdr.lookup("AccountId")],
  ["asset", xdr.lookup("Asset")],
  ["amount", xdr.lookup("Int64")],
  ["ext", xdr.lookup("PaymentOpExt")],
]);

// === xdr source ============================================================
//
//   enum PaymentResultCode
//       {
//           // codes considered as "success" for the operation
//           PAYMENT_SUCCESS = 0, // payment successfuly completed
//   
//           // codes considered as "failure" for the operation
//           PAYMENT_MALFORMED = -1,          // bad input
//           PAYMENT_UNDERFUNDED = -2,        // not enough funds in source account
//           PAYMENT_SRC_NO_TRUST = -3,       // no trust line on source account
//           PAYMENT_SRC_NOT_AUTHORIZED = -4, // source not authorized to transfer
//           PAYMENT_NO_DESTINATION = -5,     // destination account does not exist
//           PAYMENT_NO_TRUST = -6,       // destination missing a trust line for asset
//           PAYMENT_NOT_AUTHORIZED = -7, // destination not authorized to hold asset
//           PAYMENT_LINE_FULL = -8,      // destination would go above their limit
//           PAYMENT_NO_ISSUER = -9       // missing issuer on asset
//       };
//
// ===========================================================================
xdr.enum("PaymentResultCode", {
  paymentSuccess: 0,
  paymentMalformed: -1,
  paymentUnderfunded: -2,
  paymentSrcNoTrust: -3,
  paymentSrcNotAuthorized: -4,
  paymentNoDestination: -5,
  paymentNoTrust: -6,
  paymentNotAuthorized: -7,
  paymentLineFull: -8,
  paymentNoIssuer: -9,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//
// ===========================================================================
xdr.union("PaymentResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     }
//
// ===========================================================================
xdr.struct("PaymentResultSuccess", [
  ["ext", xdr.lookup("PaymentResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union PaymentResult switch (PaymentResultCode code)
//       {
//       case PAYMENT_SUCCESS:
//           struct {
//                       // reserved for future use
//                       union switch (LedgerVersion v)
//                       {
//                       case EMPTY_VERSION:
//                         void;
//                       }
//                       ext;
//                     } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("PaymentResult", {
  switchOn: xdr.lookup("PaymentResultCode"),
  switchName: "code",
  switches: [
    ["paymentSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("PaymentResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   enum ReviewableRequestType
//   {
//       REQUEST_TYPE_CREATE_LOT = 1,            // creates new lot
//       REQUEST_TYPE_REQUEST_PARTICIPATION = 2,
//       REQUEST_TYPE_CREATE_BID = 3
//   };
//
// ===========================================================================
xdr.enum("ReviewableRequestType", {
  requestTypeCreateLot: 1,
  requestTypeRequestParticipation: 2,
  requestTypeCreateBid: 3,
});

// === xdr source ============================================================
//
//   union switch(ReviewableRequestType type)
//       {
//        case REQUEST_TYPE_CREATE_LOT:
//           LotCreationRequest lotCreationRequest;
//        case REQUEST_TYPE_CREATE_BID:
//           BidRequest bidRequest;
//        case REQUEST_TYPE_REQUEST_PARTICIPATION:
//           ParticipationRequest participationRequest;
//       }
//
// ===========================================================================
xdr.union("ReviewableRequestEntryBody", {
  switchOn: xdr.lookup("ReviewableRequestType"),
  switchName: "type",
  switches: [
    ["requestTypeCreateLot", "lotCreationRequest"],
    ["requestTypeCreateBid", "bidRequest"],
    ["requestTypeRequestParticipation", "participationRequest"],
  ],
  arms: {
    lotCreationRequest: xdr.lookup("LotCreationRequest"),
    bidRequest: xdr.lookup("BidRequest"),
    participationRequest: xdr.lookup("ParticipationRequest"),
  },
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("ReviewableRequestEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ReviewableRequestEntry
//   {
//       uint64 requestID;
//       AccountID requestor;
//       AccountID reviewer;
//       Hash hash;
//       string256 rejectReason;
//       string64* reference;
//       int64 createdAt;
//   
//       // body of the request
//       union switch(ReviewableRequestType type)
//       {
//        case REQUEST_TYPE_CREATE_LOT:
//           LotCreationRequest lotCreationRequest;
//        case REQUEST_TYPE_CREATE_BID:
//           BidRequest bidRequest;
//        case REQUEST_TYPE_REQUEST_PARTICIPATION:
//           ParticipationRequest participationRequest;
//       } body;
//   
//       //reserved for future use
//       union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       } ext;
//   };
//
// ===========================================================================
xdr.struct("ReviewableRequestEntry", [
  ["requestId", xdr.lookup("Uint64")],
  ["requestor", xdr.lookup("AccountId")],
  ["reviewer", xdr.lookup("AccountId")],
  ["hash", xdr.lookup("Hash")],
  ["rejectReason", xdr.lookup("String256")],
  ["reference", xdr.option(xdr.lookup("String64"))],
  ["createdAt", xdr.lookup("Int64")],
  ["body", xdr.lookup("ReviewableRequestEntryBody")],
  ["ext", xdr.lookup("ReviewableRequestEntryExt")],
]);

// === xdr source ============================================================
//
//   enum ReviewRequestAction
//   {
//       REVIEW_REQUEST_ACTION_APPROVE = 1,
//       REVIEW_REQUEST_ACTION_REJECT = 2,
//       REVIEW_REQUEST_ACTION_PERMANENT_REJECT = 3
//   };
//
// ===========================================================================
xdr.enum("ReviewRequestAction", {
  reviewRequestActionApprove: 1,
  reviewRequestActionReject: 2,
  reviewRequestActionPermanentReject: 3,
});

// === xdr source ============================================================
//
//   union switch(ReviewableRequestType requestType)
//       {
//        case REQUEST_TYPE_CREATE_LOT:
//           void;
//        case REQUEST_TYPE_CREATE_BID:
//           void;
//        case REQUEST_TYPE_REQUEST_PARTICIPATION:
//           void;
//       }
//
// ===========================================================================
xdr.union("ReviewRequestOpRequestDetails", {
  switchOn: xdr.lookup("ReviewableRequestType"),
  switchName: "requestType",
  switches: [
    ["requestTypeCreateLot", xdr.void()],
    ["requestTypeCreateBid", xdr.void()],
    ["requestTypeRequestParticipation", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("ReviewRequestOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ReviewRequestOp
//   {
//       uint64 requestID;
//       Hash hash; // hash of the body of a request
//       ReviewRequestAction action;
//       string256 rejectReason;
//   
//       union switch(ReviewableRequestType requestType)
//       {
//        case REQUEST_TYPE_CREATE_LOT:
//           void;
//        case REQUEST_TYPE_CREATE_BID:
//           void;
//        case REQUEST_TYPE_REQUEST_PARTICIPATION:
//           void;
//       } requestDetails;
//   
//       // reserved for future use
//       union switch(LedgerVersion v)
//       {
//        case EMPTY_VERSION:
//           void;
//       } ext;
//   };
//
// ===========================================================================
xdr.struct("ReviewRequestOp", [
  ["requestId", xdr.lookup("Uint64")],
  ["hash", xdr.lookup("Hash")],
  ["action", xdr.lookup("ReviewRequestAction")],
  ["rejectReason", xdr.lookup("String256")],
  ["requestDetails", xdr.lookup("ReviewRequestOpRequestDetails")],
  ["ext", xdr.lookup("ReviewRequestOpExt")],
]);

// === xdr source ============================================================
//
//   enum ReviewRequestResultCode
//   {
//       REVIEW_REQUEST_SUCCESS = 0,
//   
//       REVIEW_REQUEST_REQUEST_NOT_FOUND = -1,
//       REVIEW_REQUEST_INVALID_REJECT_REASON = -2,
//       REVIEW_REQUEST_TYPE_MISMATCHED = -3,
//       REVIEW_REQUEST_HASH_MISMATCHED = -4,
//       REVIEW_REQUEST_REJECT_NOT_ALLOWED = -5,
//       REVIEW_REQUEST_PERMANENT_REJECT_NOT_ALLOWED = -6,
//       REVIEW_REQUEST_INVALID_VERSION = -7,
//       REVIEW_REQUEST_NO_REQUESTOR = -8,
//       REVIEW_REQUEST_REQUEST_PARTICIPATION_TOO_LATE = -9,
//       REVIEW_REQUEST_REQUEST_PARTICIPATION_BUY_NOW_ALREADY_TAKEN = -10
//   };
//
// ===========================================================================
xdr.enum("ReviewRequestResultCode", {
  reviewRequestSuccess: 0,
  reviewRequestRequestNotFound: -1,
  reviewRequestInvalidRejectReason: -2,
  reviewRequestTypeMismatched: -3,
  reviewRequestHashMismatched: -4,
  reviewRequestRejectNotAllowed: -5,
  reviewRequestPermanentRejectNotAllowed: -6,
  reviewRequestInvalidVersion: -7,
  reviewRequestNoRequestor: -8,
  reviewRequestRequestParticipationTooLate: -9,
  reviewRequestRequestParticipationBuyNowAlreadyTaken: -10,
});

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//           {
//            case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("ReviewRequestResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           //reserved for future use
//           union switch(LedgerVersion v)
//           {
//            case EMPTY_VERSION:
//               void;
//           } ext;
//       }
//
// ===========================================================================
xdr.struct("ReviewRequestResultSuccess", [
  ["ext", xdr.lookup("ReviewRequestResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union ReviewRequestResult switch(ReviewRequestResultCode code)
//   {
//    case REVIEW_REQUEST_SUCCESS:
//       struct
//       {
//           //reserved for future use
//           union switch(LedgerVersion v)
//           {
//            case EMPTY_VERSION:
//               void;
//           } ext;
//       } success;
//    default:
//       void;
//   };
//
// ===========================================================================
xdr.union("ReviewRequestResult", {
  switchOn: xdr.lookup("ReviewRequestResultCode"),
  switchName: "code",
  switches: [
    ["reviewRequestSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("ReviewRequestResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("CreateAccountOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreateAccountOp
//       {
//           AccountID destination;     // account to create
//           AccountID platformID;
//           AccountType accountType;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CreateAccountOp", [
  ["destination", xdr.lookup("AccountId")],
  ["platformId", xdr.lookup("AccountId")],
  ["accountType", xdr.lookup("AccountType")],
  ["ext", xdr.lookup("CreateAccountOpExt")],
]);

// === xdr source ============================================================
//
//   enum CreateAccountResultCode
//       {
//           // codes considered as "success" for the operation
//           CREATE_ACCOUNT_SUCCESS = 0, // account was created
//   
//           // codes considered as "failure" for the operation
//           CREATE_ACCOUNT_MALFORMED = -1,   // general problems
//           CREATE_ACCOUNT_TYPE_NOT_ALLOWED = -2,
//           CREATE_ACCOUNT_ALREADY_EXISTS = -3,
//           CREATE_ACCOUNT_PLATFORM_NOT_FOUND = -4,
//           CREATE_ACCOUNT_PLATFORM_ID_MISMATCHED = -5, // platform should belong to itself
//           CREATE_ACCOUNT_INVALID_VERSION = -6
//       };
//
// ===========================================================================
xdr.enum("CreateAccountResultCode", {
  createAccountSuccess: 0,
  createAccountMalformed: -1,
  createAccountTypeNotAllowed: -2,
  createAccountAlreadyExist: -3,
  createAccountPlatformNotFound: -4,
  createAccountPlatformIdMismatched: -5,
  createAccountInvalidVersion: -6,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                 void;
//               }
//
// ===========================================================================
xdr.union("CreateAccountResultSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct {
//               // reserved for future use
//               union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                 void;
//               }
//               ext;
//             }
//
// ===========================================================================
xdr.struct("CreateAccountResultSuccess", [
  ["ext", xdr.lookup("CreateAccountResultSuccessExt")],
]);

// === xdr source ============================================================
//
//   union CreateAccountResult switch (CreateAccountResultCode code)
//       {
//       case CREATE_ACCOUNT_SUCCESS:
//           struct {
//               // reserved for future use
//               union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                 void;
//               }
//               ext;
//             } success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("CreateAccountResult", {
  switchOn: xdr.lookup("CreateAccountResultCode"),
  switchName: "code",
  switches: [
    ["createAccountSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("CreateAccountResultSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("LotDetailsExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LotDetails
//       {
//           string details<>;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("LotDetails", [
  ["details", xdr.string()],
  ["ext", xdr.lookup("LotDetailsExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("UpdateLotOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct UpdateLotOp
//       {
//           uint64 lotID;
//   
//           LotDetails* details;     // JSON string with full lot description
//   
//           int64* startTime;        // auction start time in Unix epoch format
//           uint64* duration;        // duration in seconds (optional for certain type of lot)
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("UpdateLotOp", [
  ["lotId", xdr.lookup("Uint64")],
  ["details", xdr.option(xdr.lookup("LotDetails"))],
  ["startTime", xdr.option(xdr.lookup("Int64"))],
  ["duration", xdr.option(xdr.lookup("Uint64"))],
  ["ext", xdr.lookup("UpdateLotOpExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("UpdateLotSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct UpdateLotSuccess {
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("UpdateLotSuccess", [
  ["ext", xdr.lookup("UpdateLotSuccessExt")],
]);

// === xdr source ============================================================
//
//   enum UpdateLotResultCode
//       {
//           UPDATE_LOT_SUCCESS = 0, // lot was created
//   
//           UPDATE_LOT_NOT_FOUND = -1,
//           UPDATE_LOT_NOT_ALLOWED = -2,
//           UPDATE_LOT_MALFORMED_START_TIME = -3,
//           UPDATE_LOT_MALFORMED_DURATION = -4,
//           UPDATE_LOT_INVALID_JSON = -5
//       };
//
// ===========================================================================
xdr.enum("UpdateLotResultCode", {
  updateLotSuccess: 0,
  updateLotNotFound: -1,
  updateLotNotAllowed: -2,
  updateLotMalformedStartTime: -3,
  updateLotMalformedDuration: -4,
  updateLotInvalidJson: -5,
});

// === xdr source ============================================================
//
//   union UpdateLotResult switch (UpdateLotResultCode code)
//       {
//       case UPDATE_LOT_SUCCESS:
//           UpdateLotSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("UpdateLotResult", {
  switchOn: xdr.lookup("UpdateLotResultCode"),
  switchName: "code",
  switches: [
    ["updateLotSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("UpdateLotSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("PathPaymentOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct PathPaymentOp
//       {
//           Asset sendAsset; // asset we pay with
//           int64 sendMax;   // the maximum amount of sendAsset to
//                            // send (excluding fees).
//                            // The operation will fail if can't be met
//   
//           AccountID destination; // recipient of the payment
//           Asset destAsset;       // what they end up with
//           int64 destAmount;      // amount they end up with
//   
//           Asset path<5>; // additional hops it must go through to get there
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("PathPaymentOp", [
  ["sendAsset", xdr.lookup("Asset")],
  ["sendMax", xdr.lookup("Int64")],
  ["destination", xdr.lookup("AccountId")],
  ["destAsset", xdr.lookup("Asset")],
  ["destAmount", xdr.lookup("Int64")],
  ["path", xdr.varArray(xdr.lookup("Asset"), 5)],
  ["ext", xdr.lookup("PathPaymentOpExt")],
]);

// === xdr source ============================================================
//
//   enum PathPaymentResultCode
//       {
//           // codes considered as "success" for the operation
//           PATH_PAYMENT_SUCCESS = 0, // success
//   
//           // codes considered as "failure" for the operation
//           PATH_PAYMENT_MALFORMED = -1,          // bad input
//           PATH_PAYMENT_UNDERFUNDED = -2,        // not enough funds in source account
//           PATH_PAYMENT_SRC_NO_TRUST = -3,       // no trust line on source account
//           PATH_PAYMENT_SRC_NOT_AUTHORIZED = -4, // source not authorized to transfer
//           PATH_PAYMENT_NO_DESTINATION = -5,     // destination account does not exist
//           PATH_PAYMENT_NO_TRUST = -6,           // dest missing a trust line for asset
//           PATH_PAYMENT_NOT_AUTHORIZED = -7,     // dest not authorized to hold asset
//           PATH_PAYMENT_LINE_FULL = -8,          // dest would go above their limit
//           PATH_PAYMENT_NO_ISSUER = -9,          // missing issuer on one asset
//           PATH_PAYMENT_TOO_FEW_OFFERS = -10,    // not enough offers to satisfy path
//           PATH_PAYMENT_OFFER_CROSS_SELF = -11,  // would cross one of its own offers
//           PATH_PAYMENT_OVER_SENDMAX = -12       // could not satisfy sendmax
//       };
//
// ===========================================================================
xdr.enum("PathPaymentResultCode", {
  pathPaymentSuccess: 0,
  pathPaymentMalformed: -1,
  pathPaymentUnderfunded: -2,
  pathPaymentSrcNoTrust: -3,
  pathPaymentSrcNotAuthorized: -4,
  pathPaymentNoDestination: -5,
  pathPaymentNoTrust: -6,
  pathPaymentNotAuthorized: -7,
  pathPaymentLineFull: -8,
  pathPaymentNoIssuer: -9,
  pathPaymentTooFewOffer: -10,
  pathPaymentOfferCrossSelf: -11,
  pathPaymentOverSendmax: -12,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("SimplePaymentResultExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct SimplePaymentResult
//       {
//           AccountID destination;
//           Asset asset;
//           int64 amount;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("SimplePaymentResult", [
  ["destination", xdr.lookup("AccountId")],
  ["asset", xdr.lookup("Asset")],
  ["amount", xdr.lookup("Int64")],
  ["ext", xdr.lookup("SimplePaymentResultExt")],
]);

// === xdr source ============================================================
//
//   struct
//           {
//               ClaimOfferAtom offers<>;
//               SimplePaymentResult last;
//           }
//
// ===========================================================================
xdr.struct("PathPaymentResultSuccess", [
  ["offers", xdr.varArray(xdr.lookup("ClaimOfferAtom"), 2147483647)],
  ["last", xdr.lookup("SimplePaymentResult")],
]);

// === xdr source ============================================================
//
//   union PathPaymentResult switch (PathPaymentResultCode code)
//       {
//       case PATH_PAYMENT_SUCCESS:
//           struct
//           {
//               ClaimOfferAtom offers<>;
//               SimplePaymentResult last;
//           } success;
//       case PATH_PAYMENT_NO_ISSUER:
//           Asset noIssuer; // the asset that caused the error
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("PathPaymentResult", {
  switchOn: xdr.lookup("PathPaymentResultCode"),
  switchName: "code",
  switches: [
    ["pathPaymentSuccess", "success"],
    ["pathPaymentNoIssuer", "noIssuer"],
  ],
  arms: {
    success: xdr.lookup("PathPaymentResultSuccess"),
    noIssuer: xdr.lookup("Asset"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   enum AssetType
//       {
//           ASSET_TYPE_NATIVE = 0,
//           ASSET_TYPE_CREDIT_ALPHANUM4 = 1,
//           ASSET_TYPE_CREDIT_ALPHANUM12 = 2
//       };
//
// ===========================================================================
xdr.enum("AssetType", {
  assetTypeNative: 0,
  assetTypeCreditAlphanum4: 1,
  assetTypeCreditAlphanum12: 2,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//
// ===========================================================================
xdr.union("AssetAlphaNum4Ext", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//               {
//                   opaque assetCode[4]; // 1 to 4 characters
//                   AccountID issuer;
//                   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//                           ext;
//               }
//
// ===========================================================================
xdr.struct("AssetAlphaNum4", [
  ["assetCode", xdr.opaque(4)],
  ["issuer", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("AssetAlphaNum4Ext")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//
// ===========================================================================
xdr.union("AssetAlphaNum12Ext", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//               {
//                   opaque assetCode[12]; // 5 to 12 characters
//                   AccountID issuer;
//                   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//                           ext;
//               }
//
// ===========================================================================
xdr.struct("AssetAlphaNum12", [
  ["assetCode", xdr.opaque(12)],
  ["issuer", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("AssetAlphaNum12Ext")],
]);

// === xdr source ============================================================
//
//   union Asset switch (AssetType type)
//       {
//           case ASSET_TYPE_NATIVE: // Not credit
//               void;
//           case ASSET_TYPE_CREDIT_ALPHANUM4:
//               struct
//               {
//                   opaque assetCode[4]; // 1 to 4 characters
//                   AccountID issuer;
//                   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//                           ext;
//               } alphaNum4;
//           case ASSET_TYPE_CREDIT_ALPHANUM12:
//               struct
//               {
//                   opaque assetCode[12]; // 5 to 12 characters
//                   AccountID issuer;
//                   union switch (LedgerVersion v)
//                           {
//                           case EMPTY_VERSION:
//                               void;
//                           }
//                           ext;
//               } alphaNum12;
//               // add other asset types here in the future
//       };
//
// ===========================================================================
xdr.union("Asset", {
  switchOn: xdr.lookup("AssetType"),
  switchName: "type",
  switches: [
    ["assetTypeNative", xdr.void()],
    ["assetTypeCreditAlphanum4", "alphaNum4"],
    ["assetTypeCreditAlphanum12", "alphaNum12"],
  ],
  arms: {
    alphaNum4: xdr.lookup("AssetAlphaNum4"),
    alphaNum12: xdr.lookup("AssetAlphaNum12"),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("PriceExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct Price
//       {
//           int32 n; // numerator
//           int32 d; // denominator
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("Price", [
  ["n", xdr.lookup("Int32")],
  ["d", xdr.lookup("Int32")],
  ["ext", xdr.lookup("PriceExt")],
]);

// === xdr source ============================================================
//
//   enum LotType {
//           LOT_TYPE_NO_AUCTION = 0,
//           LOT_TYPE_ENG = 1,
//           LOT_TYPE_COPART = 2
//       };
//
// ===========================================================================
xdr.enum("LotType", {
  lotTypeNoAuction: 0,
  lotTypeEng: 1,
  lotTypeCopart: 2,
});

// === xdr source ============================================================
//
//   enum LotState {
//           LOT_STATE_PENDING = 1,
//           LOT_STATE_SOLD = 2,
//           LOT_STATE_FINISHED = 3
//       };
//
// ===========================================================================
xdr.enum("LotState", {
  lotStatePending: 1,
  lotStateSold: 2,
  lotStateFinished: 3,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("LotEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LotEntry
//       {
//           uint64 lotID;
//           AccountID organizerID;  // lot organizer
//           AccountID platformID;   // platform
//   
//           AccountID* winnerID;
//           LotState state;
//   
//           LotType lotType;
//           bool buyNowSupport;
//           string details<>;       // JSON string with full lot description
//   
//           int64 startTime;        // auction start time in Unix epoch format
//           uint64 duration;        // duration in seconds
//   
//           string currency<3>;     // need to keep this here in order to be sure
//                                   // that all the lots have proper currency
//           uint64 startPrice;      // all prices are indicated in cents
//           uint64 deposit;         // minimal deposit to pay for participating
//           uint64 buyNowPrice;
//           uint64 minStep;
//           uint64 maxStep;
//   
//           int64 createdAt;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("LotEntry", [
  ["lotId", xdr.lookup("Uint64")],
  ["organizerId", xdr.lookup("AccountId")],
  ["platformId", xdr.lookup("AccountId")],
  ["winnerId", xdr.option(xdr.lookup("AccountId"))],
  ["state", xdr.lookup("LotState")],
  ["lotType", xdr.lookup("LotType")],
  ["buyNowSupport", xdr.bool()],
  ["details", xdr.string()],
  ["startTime", xdr.lookup("Int64")],
  ["duration", xdr.lookup("Uint64")],
  ["currency", xdr.string(3)],
  ["startPrice", xdr.lookup("Uint64")],
  ["deposit", xdr.lookup("Uint64")],
  ["buyNowPrice", xdr.lookup("Uint64")],
  ["minStep", xdr.lookup("Uint64")],
  ["maxStep", xdr.lookup("Uint64")],
  ["createdAt", xdr.lookup("Int64")],
  ["ext", xdr.lookup("LotEntryExt")],
]);

// === xdr source ============================================================
//
//   typedef opaque Value<>;
//
// ===========================================================================
xdr.typedef("Value", xdr.varOpaque());

// === xdr source ============================================================
//
//   struct SCPBallot
//   {
//       uint32 counter; // n
//       Value value;    // x
//   };
//
// ===========================================================================
xdr.struct("ScpBallot", [
  ["counter", xdr.lookup("Uint32")],
  ["value", xdr.lookup("Value")],
]);

// === xdr source ============================================================
//
//   enum SCPStatementType
//   {
//       SCP_ST_PREPARE = 0,
//       SCP_ST_CONFIRM = 1,
//       SCP_ST_EXTERNALIZE = 2,
//       SCP_ST_NOMINATE = 3
//   };
//
// ===========================================================================
xdr.enum("ScpStatementType", {
  scpStPrepare: 0,
  scpStConfirm: 1,
  scpStExternalize: 2,
  scpStNominate: 3,
});

// === xdr source ============================================================
//
//   struct SCPNomination
//   {
//       Hash quorumSetHash; // D
//       Value votes<>;      // X
//       Value accepted<>;   // Y
//   };
//
// ===========================================================================
xdr.struct("ScpNomination", [
  ["quorumSetHash", xdr.lookup("Hash")],
  ["votes", xdr.varArray(xdr.lookup("Value"), 2147483647)],
  ["accepted", xdr.varArray(xdr.lookup("Value"), 2147483647)],
]);

// === xdr source ============================================================
//
//   struct
//           {
//               Hash quorumSetHash;       // D
//               SCPBallot ballot;         // b
//               SCPBallot* prepared;      // p
//               SCPBallot* preparedPrime; // p'
//               uint32 nC;                // c.n
//               uint32 nH;                // h.n
//           }
//
// ===========================================================================
xdr.struct("ScpStatementPrepare", [
  ["quorumSetHash", xdr.lookup("Hash")],
  ["ballot", xdr.lookup("ScpBallot")],
  ["prepared", xdr.option(xdr.lookup("ScpBallot"))],
  ["preparedPrime", xdr.option(xdr.lookup("ScpBallot"))],
  ["nC", xdr.lookup("Uint32")],
  ["nH", xdr.lookup("Uint32")],
]);

// === xdr source ============================================================
//
//   struct
//           {
//               SCPBallot ballot;   // b
//               uint32 nPrepared;   // p.n
//               uint32 nCommit;     // c.n
//               uint32 nH;          // h.n
//               Hash quorumSetHash; // D
//           }
//
// ===========================================================================
xdr.struct("ScpStatementConfirm", [
  ["ballot", xdr.lookup("ScpBallot")],
  ["nPrepared", xdr.lookup("Uint32")],
  ["nCommit", xdr.lookup("Uint32")],
  ["nH", xdr.lookup("Uint32")],
  ["quorumSetHash", xdr.lookup("Hash")],
]);

// === xdr source ============================================================
//
//   struct
//           {
//               SCPBallot commit;         // c
//               uint32 nH;                // h.n
//               Hash commitQuorumSetHash; // D used before EXTERNALIZE
//           }
//
// ===========================================================================
xdr.struct("ScpStatementExternalize", [
  ["commit", xdr.lookup("ScpBallot")],
  ["nH", xdr.lookup("Uint32")],
  ["commitQuorumSetHash", xdr.lookup("Hash")],
]);

// === xdr source ============================================================
//
//   union switch (SCPStatementType type)
//       {
//       case SCP_ST_PREPARE:
//           struct
//           {
//               Hash quorumSetHash;       // D
//               SCPBallot ballot;         // b
//               SCPBallot* prepared;      // p
//               SCPBallot* preparedPrime; // p'
//               uint32 nC;                // c.n
//               uint32 nH;                // h.n
//           } prepare;
//       case SCP_ST_CONFIRM:
//           struct
//           {
//               SCPBallot ballot;   // b
//               uint32 nPrepared;   // p.n
//               uint32 nCommit;     // c.n
//               uint32 nH;          // h.n
//               Hash quorumSetHash; // D
//           } confirm;
//       case SCP_ST_EXTERNALIZE:
//           struct
//           {
//               SCPBallot commit;         // c
//               uint32 nH;                // h.n
//               Hash commitQuorumSetHash; // D used before EXTERNALIZE
//           } externalize;
//       case SCP_ST_NOMINATE:
//           SCPNomination nominate;
//       }
//
// ===========================================================================
xdr.union("ScpStatementPledges", {
  switchOn: xdr.lookup("ScpStatementType"),
  switchName: "type",
  switches: [
    ["scpStPrepare", "prepare"],
    ["scpStConfirm", "confirm"],
    ["scpStExternalize", "externalize"],
    ["scpStNominate", "nominate"],
  ],
  arms: {
    prepare: xdr.lookup("ScpStatementPrepare"),
    confirm: xdr.lookup("ScpStatementConfirm"),
    externalize: xdr.lookup("ScpStatementExternalize"),
    nominate: xdr.lookup("ScpNomination"),
  },
});

// === xdr source ============================================================
//
//   struct SCPStatement
//   {
//       NodeID nodeID;    // v
//       uint64 slotIndex; // i
//   
//       union switch (SCPStatementType type)
//       {
//       case SCP_ST_PREPARE:
//           struct
//           {
//               Hash quorumSetHash;       // D
//               SCPBallot ballot;         // b
//               SCPBallot* prepared;      // p
//               SCPBallot* preparedPrime; // p'
//               uint32 nC;                // c.n
//               uint32 nH;                // h.n
//           } prepare;
//       case SCP_ST_CONFIRM:
//           struct
//           {
//               SCPBallot ballot;   // b
//               uint32 nPrepared;   // p.n
//               uint32 nCommit;     // c.n
//               uint32 nH;          // h.n
//               Hash quorumSetHash; // D
//           } confirm;
//       case SCP_ST_EXTERNALIZE:
//           struct
//           {
//               SCPBallot commit;         // c
//               uint32 nH;                // h.n
//               Hash commitQuorumSetHash; // D used before EXTERNALIZE
//           } externalize;
//       case SCP_ST_NOMINATE:
//           SCPNomination nominate;
//       }
//       pledges;
//   };
//
// ===========================================================================
xdr.struct("ScpStatement", [
  ["nodeId", xdr.lookup("NodeId")],
  ["slotIndex", xdr.lookup("Uint64")],
  ["pledges", xdr.lookup("ScpStatementPledges")],
]);

// === xdr source ============================================================
//
//   struct SCPEnvelope
//   {
//       SCPStatement statement;
//       Signature signature;
//   };
//
// ===========================================================================
xdr.struct("ScpEnvelope", [
  ["statement", xdr.lookup("ScpStatement")],
  ["signature", xdr.lookup("Signature")],
]);

// === xdr source ============================================================
//
//   struct SCPQuorumSet
//   {
//       uint32 threshold;
//   	uint32 thresholdPercent;
//   	bool isUpdated;
//       PublicKey trustValidators<>;
//       PublicKey validators<>;
//       SCPQuorumSet innerSets<>;
//   };
//
// ===========================================================================
xdr.struct("ScpQuorumSet", [
  ["threshold", xdr.lookup("Uint32")],
  ["thresholdPercent", xdr.lookup("Uint32")],
  ["isUpdated", xdr.bool()],
  ["trustValidators", xdr.varArray(xdr.lookup("PublicKey"), 2147483647)],
  ["validators", xdr.varArray(xdr.lookup("PublicKey"), 2147483647)],
  ["innerSets", xdr.varArray(xdr.lookup("ScpQuorumSet"), 2147483647)],
]);

// === xdr source ============================================================
//
//   enum ParticipantState {
//           PARTICIPANT_STATE_PENDING = 0,
//           PARTICIPANT_STATE_REJECTED = 1,
//           PARTICIPANT_STATE_WINNER = 2,
//           PARTICIPANT_STATE_BUY_NOW_WINNER = 3
//       };
//
// ===========================================================================
xdr.enum("ParticipantState", {
  participantStatePending: 0,
  participantStateRejected: 1,
  participantStateWinner: 2,
  participantStateBuyNowWinner: 3,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("ParticipantEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct ParticipantEntry
//       {
//           AccountID accountID;
//           uint64 lotID;
//   
//           ParticipantState state;
//           bool buyNow;
//   
//           uint64 bestBid;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("ParticipantEntry", [
  ["accountId", xdr.lookup("AccountId")],
  ["lotId", xdr.lookup("Uint64")],
  ["state", xdr.lookup("ParticipantState")],
  ["buyNow", xdr.bool()],
  ["bestBid", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("ParticipantEntryExt")],
]);

// === xdr source ============================================================
//
//   enum OfferEntryFlags
//       {
//           // issuer has authorized account to perform transactions with its credit
//           PASSIVE_FLAG = 1
//       };
//
// ===========================================================================
xdr.enum("OfferEntryFlags", {
  passiveFlag: 1,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("OfferEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct OfferEntry
//       {
//           AccountID sellerID;
//           uint64 offerID;
//           Asset selling; // A
//           Asset buying;  // B
//           int64 amount;  // amount of A
//   
//           /* price for this offer:
//               price of A in terms of B
//               price=AmountB/AmountA=priceNumerator/priceDenominator
//               price is after fees
//           */
//           Price price;
//           uint32 flags; // see OfferEntryFlags
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("OfferEntry", [
  ["sellerId", xdr.lookup("AccountId")],
  ["offerId", xdr.lookup("Uint64")],
  ["selling", xdr.lookup("Asset")],
  ["buying", xdr.lookup("Asset")],
  ["amount", xdr.lookup("Int64")],
  ["price", xdr.lookup("Price")],
  ["flags", xdr.lookup("Uint32")],
  ["ext", xdr.lookup("OfferEntryExt")],
]);

// === xdr source ============================================================
//
//   enum CloseAuctionAction
//       {
//           CLOSE_AUCTION_ACTION_MARK_SOLD = 1,
//           CLOSE_AUCTION_ACTION_MARK_FINISHED = 2
//       };
//
// ===========================================================================
xdr.enum("CloseAuctionAction", {
  closeAuctionActionMarkSold: 1,
  closeAuctionActionMarkFinished: 2,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CloseAuctionOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CloseAuctionOp
//       {
//           CloseAuctionAction action;
//           uint64 lotID;
//   
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CloseAuctionOp", [
  ["action", xdr.lookup("CloseAuctionAction")],
  ["lotId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("CloseAuctionOpExt")],
]);

// === xdr source ============================================================
//
//   enum CloseAuctionResultCode
//       {
//           CLOSE_AUCTION_SUCCESS = 0,
//   
//           CLOSE_AUCTION_NOT_FOUND = -1,        // lot not found
//           CLOSE_AUCTION_TOO_EARLY = -2,        // can't close auction before
//           CLOSE_AUCTION_NO_WINNERS = -3,       // can't mark as winner since there are no participants with state winner
//           CLOSE_AUCTION_ALREADY_CLOSED = -4,   // lot is already closed
//           CLOSE_AUCTION_HAS_WINNER = -5,       // can't mark as finished since lot has winner participant
//           CLOSE_AUCTION_NOT_ALLOWED = -6       // only platform can resolve auction
//       };
//
// ===========================================================================
xdr.enum("CloseAuctionResultCode", {
  closeAuctionSuccess: 0,
  closeAuctionNotFound: -1,
  closeAuctionTooEarly: -2,
  closeAuctionNoWinner: -3,
  closeAuctionAlreadyClosed: -4,
  closeAuctionHasWinner: -5,
  closeAuctionNotAllowed: -6,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("CloseAuctionSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CloseAuctionSuccess
//       {
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("CloseAuctionSuccess", [
  ["ext", xdr.lookup("CloseAuctionSuccessExt")],
]);

// === xdr source ============================================================
//
//   union CloseAuctionResult switch (CloseAuctionResultCode code)
//       {
//       case CLOSE_AUCTION_SUCCESS:
//           CloseAuctionSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("CloseAuctionResult", {
  switchOn: xdr.lookup("CloseAuctionResultCode"),
  switchName: "code",
  switches: [
    ["closeAuctionSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("CloseAuctionSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("RecoverOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RecoverOp
//       {
//           AccountID account;
//           AccountID newSigner;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RecoverOp", [
  ["account", xdr.lookup("AccountId")],
  ["newSigner", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("RecoverOpExt")],
]);

// === xdr source ============================================================
//
//   enum RecoverResultCode
//       {
//           // codes considered as "success" for the operation
//           RECOVER_SUCCESS = 0,
//   
//           // codes considered as "failure" for the operation
//           RECOVER_MALFORMED = -1,
//           RECOVER_IS_NOT_PLATFORM = -2,
//           RECOVER_ACCOUNT_NOT_FOUND = -3,
//           RECOVER_SIGNER_ALREADY_EXISTS = -4,
//           RECOVER_ACCOUNT_TYPE_NOT_ALLOWED = -5
//       };
//
// ===========================================================================
xdr.enum("RecoverResultCode", {
  recoverSuccess: 0,
  recoverMalformed: -1,
  recoverIsNotPlatform: -2,
  recoverAccountNotFound: -3,
  recoverSignerAlreadyExist: -4,
  recoverAccountTypeNotAllowed: -5,
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("RecoverSuccessExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct RecoverSuccess
//       {
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("RecoverSuccess", [
  ["ext", xdr.lookup("RecoverSuccessExt")],
]);

// === xdr source ============================================================
//
//   union RecoverResult switch (RecoverResultCode code)
//       {
//       case RECOVER_SUCCESS:
//           RecoverSuccess success;
//       default:
//           void;
//       };
//
// ===========================================================================
xdr.union("RecoverResult", {
  switchOn: xdr.lookup("RecoverResultCode"),
  switchName: "code",
  switches: [
    ["recoverSuccess", "success"],
  ],
  arms: {
    success: xdr.lookup("RecoverSuccess"),
  },
  defaultArm: xdr.void(),
});

// === xdr source ============================================================
//
//   enum ThresholdIndexes
//       {
//           THRESHOLD_MASTER_WEIGHT = 0,
//           THRESHOLD_LOW = 1,
//           THRESHOLD_MED = 2,
//           THRESHOLD_HIGH = 3
//       };
//
// ===========================================================================
xdr.enum("ThresholdIndices", {
  thresholdMasterWeight: 0,
  thresholdLow: 1,
  thresholdMed: 2,
  thresholdHigh: 3,
});

// === xdr source ============================================================
//
//   enum LedgerEntryType
//       {
//           ACCOUNT = 0,
//           TRUSTLINE = 1,
//           OFFER = 2,
//           LOT = 3,
//           PARTICIPANT = 4,
//           MESSAGE = 5,
//           MIGRATION =6,
//           REVIEWABLE_REQUEST = 7,
//           REFERENCE = 8
//       };
//
// ===========================================================================
xdr.enum("LedgerEntryType", {
  account: 0,
  trustline: 1,
  offer: 2,
  lot: 3,
  participant: 4,
  message: 5,
  migration: 6,
  reviewableRequest: 7,
  reference: 8,
});

// === xdr source ============================================================
//
//   union switch (LedgerEntryType type)
//           {
//           case ACCOUNT:
//               AccountEntry account;
//           case TRUSTLINE:
//               TrustLineEntry trustLine;
//           case OFFER:
//               OfferEntry offer;
//           case LOT:
//               LotEntry lot;
//           case PARTICIPANT:
//               ParticipantEntry participant;
//           case MESSAGE:
//               MessageEntry message;
//           case MIGRATION:
//               MigrationEntry migration;
//           case REVIEWABLE_REQUEST:
//               ReviewableRequestEntry reviewableRequest;
//           case REFERENCE:
//               ReferenceEntry reference;
//           }
//
// ===========================================================================
xdr.union("LedgerEntryData", {
  switchOn: xdr.lookup("LedgerEntryType"),
  switchName: "type",
  switches: [
    ["account", "account"],
    ["trustline", "trustLine"],
    ["offer", "offer"],
    ["lot", "lot"],
    ["participant", "participant"],
    ["message", "message"],
    ["migration", "migration"],
    ["reviewableRequest", "reviewableRequest"],
    ["reference", "reference"],
  ],
  arms: {
    account: xdr.lookup("AccountEntry"),
    trustLine: xdr.lookup("TrustLineEntry"),
    offer: xdr.lookup("OfferEntry"),
    lot: xdr.lookup("LotEntry"),
    participant: xdr.lookup("ParticipantEntry"),
    message: xdr.lookup("MessageEntry"),
    migration: xdr.lookup("MigrationEntry"),
    reviewableRequest: xdr.lookup("ReviewableRequestEntry"),
    reference: xdr.lookup("ReferenceEntry"),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("LedgerEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LedgerEntry
//       {
//           uint32 lastModifiedLedgerSeq; // ledger the LedgerEntry was last changed
//   
//           union switch (LedgerEntryType type)
//           {
//           case ACCOUNT:
//               AccountEntry account;
//           case TRUSTLINE:
//               TrustLineEntry trustLine;
//           case OFFER:
//               OfferEntry offer;
//           case LOT:
//               LotEntry lot;
//           case PARTICIPANT:
//               ParticipantEntry participant;
//           case MESSAGE:
//               MessageEntry message;
//           case MIGRATION:
//               MigrationEntry migration;
//           case REVIEWABLE_REQUEST:
//               ReviewableRequestEntry reviewableRequest;
//           case REFERENCE:
//               ReferenceEntry reference;
//           }
//           data;
//   
//           // reserved for future use
//           union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       };
//
// ===========================================================================
xdr.struct("LedgerEntry", [
  ["lastModifiedLedgerSeq", xdr.lookup("Uint32")],
  ["data", xdr.lookup("LedgerEntryData")],
  ["ext", xdr.lookup("LedgerEntryExt")],
]);

// === xdr source ============================================================
//
//   enum EnvelopeType
//       {
//           ENVELOPE_TYPE_SCP = 1,
//           ENVELOPE_TYPE_TX = 2,
//           ENVELOPE_TYPE_AUTH = 3
//       };
//
// ===========================================================================
xdr.enum("EnvelopeType", {
  envelopeTypeScp: 1,
  envelopeTypeTx: 2,
  envelopeTypeAuth: 3,
});

// === xdr source ============================================================
//
//   typedef opaque UpgradeType<128>;
//
// ===========================================================================
xdr.typedef("UpgradeType", xdr.varOpaque(128));

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("StellarValueExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct StellarValue
//   {
//       Hash txSetHash;   // transaction set to apply to previous ledger
//       uint64 closeTime; // network close time
//   
//       // upgrades to apply to the previous ledger (usually empty)
//       // this is a vector of encoded 'LedgerUpgrade' so that nodes can drop
//       // unknown steps during consensus if needed.
//       // see notes below on 'LedgerUpgrade' for more detail
//       // max size is dictated by number of upgrade types (+ room for future)
//       UpgradeType upgrades<6>;
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("StellarValue", [
  ["txSetHash", xdr.lookup("Hash")],
  ["closeTime", xdr.lookup("Uint64")],
  ["upgrades", xdr.varArray(xdr.lookup("UpgradeType"), 6)],
  ["ext", xdr.lookup("StellarValueExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("LedgerHeaderExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LedgerHeader
//   {
//       uint32 ledgerVersion;    // the protocol version of the ledger
//       Hash previousLedgerHash; // hash of the previous ledger header
//       StellarValue scpValue;   // what consensus agreed to
//       Hash txSetResultHash;    // the TransactionResultSet that led to this ledger
//       Hash bucketListHash;     // hash of the ledger state
//   
//       uint32 ledgerSeq; // sequence number of this ledger
//   
//       int64 totalCoins; // total number of stroops in existence.
//                         // 10,000,000 stroops in 1 XLM
//   
//       int64 feePool;       // fees burned since last inflation run
//       uint32 inflationSeq; // inflation sequence number
//   
//       uint64 idPool; // last used global ID, used for generating objects
//   
//       uint32 baseFee;     // base fee per operation in stroops
//       uint32 baseReserve; // account base reserve in stroops
//   
//       uint32 maxTxSetSize; // maximum size a transaction set can be
//   
//       Hash skipList[4]; // hashes of ledgers in the past. allows you to jump back
//                         // in time without walking the chain back ledger by ledger
//                         // each slot contains the oldest ledger that is mod of
//                         // either 50  5000  50000 or 500000 depending on index
//                         // skipList[0] mod(50), skipList[1] mod(5000), etc
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("LedgerHeader", [
  ["ledgerVersion", xdr.lookup("Uint32")],
  ["previousLedgerHash", xdr.lookup("Hash")],
  ["scpValue", xdr.lookup("StellarValue")],
  ["txSetResultHash", xdr.lookup("Hash")],
  ["bucketListHash", xdr.lookup("Hash")],
  ["ledgerSeq", xdr.lookup("Uint32")],
  ["totalCoins", xdr.lookup("Int64")],
  ["feePool", xdr.lookup("Int64")],
  ["inflationSeq", xdr.lookup("Uint32")],
  ["idPool", xdr.lookup("Uint64")],
  ["baseFee", xdr.lookup("Uint32")],
  ["baseReserve", xdr.lookup("Uint32")],
  ["maxTxSetSize", xdr.lookup("Uint32")],
  ["skipList", xdr.array(xdr.lookup("Hash"), 4)],
  ["ext", xdr.lookup("LedgerHeaderExt")],
]);

// === xdr source ============================================================
//
//   enum LedgerUpgradeType
//   {
//       LEDGER_UPGRADE_VERSION = 1,
//       LEDGER_UPGRADE_BASE_FEE = 2,
//       LEDGER_UPGRADE_MAX_TX_SET_SIZE = 3
//   };
//
// ===========================================================================
xdr.enum("LedgerUpgradeType", {
  ledgerUpgradeVersion: 1,
  ledgerUpgradeBaseFee: 2,
  ledgerUpgradeMaxTxSetSize: 3,
});

// === xdr source ============================================================
//
//   union LedgerUpgrade switch (LedgerUpgradeType type)
//   {
//   case LEDGER_UPGRADE_VERSION:
//       uint32 newLedgerVersion; // update ledgerVersion
//   case LEDGER_UPGRADE_BASE_FEE:
//       uint32 newBaseFee; // update baseFee
//   case LEDGER_UPGRADE_MAX_TX_SET_SIZE:
//       uint32 newMaxTxSetSize; // update maxTxSetSize
//   };
//
// ===========================================================================
xdr.union("LedgerUpgrade", {
  switchOn: xdr.lookup("LedgerUpgradeType"),
  switchName: "type",
  switches: [
    ["ledgerUpgradeVersion", "newLedgerVersion"],
    ["ledgerUpgradeBaseFee", "newBaseFee"],
    ["ledgerUpgradeMaxTxSetSize", "newMaxTxSetSize"],
  ],
  arms: {
    newLedgerVersion: xdr.lookup("Uint32"),
    newBaseFee: xdr.lookup("Uint32"),
    newMaxTxSetSize: xdr.lookup("Uint32"),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("LedgerKeyAccountExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           AccountID accountID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyAccount", [
  ["accountId", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("LedgerKeyAccountExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("LedgerKeyTrustLineExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           AccountID accountID;
//           Asset asset;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyTrustLine", [
  ["accountId", xdr.lookup("AccountId")],
  ["asset", xdr.lookup("Asset")],
  ["ext", xdr.lookup("LedgerKeyTrustLineExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("LedgerKeyOfferExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           AccountID sellerID;
//           uint64 offerID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyOffer", [
  ["sellerId", xdr.lookup("AccountId")],
  ["offerId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("LedgerKeyOfferExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("LedgerKeyLotExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           uint64 lotID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyLot", [
  ["lotId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("LedgerKeyLotExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("LedgerKeyParticipantExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           uint64 lotID;
//           AccountID accountID;
//   
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyParticipant", [
  ["lotId", xdr.lookup("Uint64")],
  ["accountId", xdr.lookup("AccountId")],
  ["ext", xdr.lookup("LedgerKeyParticipantExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("LedgerKeyMessageExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//       uint64 messageID;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyMessage", [
  ["messageId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("LedgerKeyMessageExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("LedgerKeyMigrationExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           MigrationVersion migrationVersion;
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//               ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyMigration", [
  ["migrationVersion", xdr.lookup("MigrationVersion")],
  ["ext", xdr.lookup("LedgerKeyMigrationExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("LedgerKeyReviewableRequestExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           uint64 requestID;
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyReviewableRequest", [
  ["requestId", xdr.lookup("Uint64")],
  ["ext", xdr.lookup("LedgerKeyReviewableRequestExt")],
]);

// === xdr source ============================================================
//
//   union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//
// ===========================================================================
xdr.union("LedgerKeyReferenceExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct
//       {
//           AccountID sender;
//           string64 reference;
//           union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       }
//
// ===========================================================================
xdr.struct("LedgerKeyReference", [
  ["sender", xdr.lookup("AccountId")],
  ["reference", xdr.lookup("String64")],
  ["ext", xdr.lookup("LedgerKeyReferenceExt")],
]);

// === xdr source ============================================================
//
//   union LedgerKey switch (LedgerEntryType type)
//   {
//   case ACCOUNT:
//       struct
//       {
//           AccountID accountID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       } account;
//   
//   case TRUSTLINE:
//       struct
//       {
//           AccountID accountID;
//           Asset asset;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       } trustLine;
//   
//   case OFFER:
//       struct
//       {
//           AccountID sellerID;
//           uint64 offerID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       } offer;
//   case LOT:
//       struct
//       {
//           uint64 lotID;
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       } lot;
//   case PARTICIPANT:
//       struct
//       {
//           uint64 lotID;
//           AccountID accountID;
//   
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       } participant;
//   case MESSAGE:
//       struct
//       {
//       uint64 messageID;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//       } message;
//   case MIGRATION:
//       struct
//       {
//           MigrationVersion migrationVersion;
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//               ext;
//       } migration;
//   case REVIEWABLE_REQUEST:
//       struct
//       {
//           uint64 requestID;
//           union switch (LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       } reviewableRequest;
//   case REFERENCE:
//       struct
//       {
//           AccountID sender;
//           string64 reference;
//           union switch(LedgerVersion v)
//           {
//               case EMPTY_VERSION:
//                   void;
//           }
//           ext;
//       } reference;
//   };
//
// ===========================================================================
xdr.union("LedgerKey", {
  switchOn: xdr.lookup("LedgerEntryType"),
  switchName: "type",
  switches: [
    ["account", "account"],
    ["trustline", "trustLine"],
    ["offer", "offer"],
    ["lot", "lot"],
    ["participant", "participant"],
    ["message", "message"],
    ["migration", "migration"],
    ["reviewableRequest", "reviewableRequest"],
    ["reference", "reference"],
  ],
  arms: {
    account: xdr.lookup("LedgerKeyAccount"),
    trustLine: xdr.lookup("LedgerKeyTrustLine"),
    offer: xdr.lookup("LedgerKeyOffer"),
    lot: xdr.lookup("LedgerKeyLot"),
    participant: xdr.lookup("LedgerKeyParticipant"),
    message: xdr.lookup("LedgerKeyMessage"),
    migration: xdr.lookup("LedgerKeyMigration"),
    reviewableRequest: xdr.lookup("LedgerKeyReviewableRequest"),
    reference: xdr.lookup("LedgerKeyReference"),
  },
});

// === xdr source ============================================================
//
//   enum BucketEntryType
//   {
//       LIVEENTRY = 0,
//       DEADENTRY = 1
//   };
//
// ===========================================================================
xdr.enum("BucketEntryType", {
  liveentry: 0,
  deadentry: 1,
});

// === xdr source ============================================================
//
//   union BucketEntry switch (BucketEntryType type)
//   {
//   case LIVEENTRY:
//       LedgerEntry liveEntry;
//   
//   case DEADENTRY:
//       LedgerKey deadEntry;
//   };
//
// ===========================================================================
xdr.union("BucketEntry", {
  switchOn: xdr.lookup("BucketEntryType"),
  switchName: "type",
  switches: [
    ["liveentry", "liveEntry"],
    ["deadentry", "deadEntry"],
  ],
  arms: {
    liveEntry: xdr.lookup("LedgerEntry"),
    deadEntry: xdr.lookup("LedgerKey"),
  },
});

// === xdr source ============================================================
//
//   const MAX_TX_PER_LEDGER = 5000;
//
// ===========================================================================
xdr.const("MAX_TX_PER_LEDGER", 5000);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionSetExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionSet
//   {
//       Hash previousLedgerHash;
//       TransactionEnvelope txs<MAX_TX_PER_LEDGER>;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("TransactionSet", [
  ["previousLedgerHash", xdr.lookup("Hash")],
  ["txes", xdr.varArray(xdr.lookup("TransactionEnvelope"), xdr.lookup("MAX_TX_PER_LEDGER"))],
  ["ext", xdr.lookup("TransactionSetExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionResultPairExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionResultPair
//   {
//       Hash transactionHash;
//       TransactionResult result; // result for the transaction
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("TransactionResultPair", [
  ["transactionHash", xdr.lookup("Hash")],
  ["result", xdr.lookup("TransactionResult")],
  ["ext", xdr.lookup("TransactionResultPairExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//
// ===========================================================================
xdr.union("TransactionResultSetExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionResultSet
//   {
//       TransactionResultPair results<MAX_TX_PER_LEDGER>;
//       union switch (LedgerVersion v)
//           {
//           case EMPTY_VERSION:
//               void;
//           }
//           ext;
//   };
//
// ===========================================================================
xdr.struct("TransactionResultSet", [
  ["results", xdr.varArray(xdr.lookup("TransactionResultPair"), xdr.lookup("MAX_TX_PER_LEDGER"))],
  ["ext", xdr.lookup("TransactionResultSetExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("TransactionHistoryEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionHistoryEntry
//   {
//       uint32 ledgerSeq;
//       TransactionSet txSet;
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("TransactionHistoryEntry", [
  ["ledgerSeq", xdr.lookup("Uint32")],
  ["txSet", xdr.lookup("TransactionSet")],
  ["ext", xdr.lookup("TransactionHistoryEntryExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("TransactionHistoryResultEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct TransactionHistoryResultEntry
//   {
//       uint32 ledgerSeq;
//       TransactionResultSet txResultSet;
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("TransactionHistoryResultEntry", [
  ["ledgerSeq", xdr.lookup("Uint32")],
  ["txResultSet", xdr.lookup("TransactionResultSet")],
  ["ext", xdr.lookup("TransactionHistoryResultEntryExt")],
]);

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//
// ===========================================================================
xdr.union("LedgerHeaderHistoryEntryExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct LedgerHeaderHistoryEntry
//   {
//       Hash hash;
//       LedgerHeader header;
//   
//       // reserved for future use
//       union switch (LedgerVersion v)
//       {
//       case EMPTY_VERSION:
//           void;
//       }
//       ext;
//   };
//
// ===========================================================================
xdr.struct("LedgerHeaderHistoryEntry", [
  ["hash", xdr.lookup("Hash")],
  ["header", xdr.lookup("LedgerHeader")],
  ["ext", xdr.lookup("LedgerHeaderHistoryEntryExt")],
]);

// === xdr source ============================================================
//
//   struct LedgerSCPMessages
//   {
//       uint32 ledgerSeq;
//       SCPEnvelope messages<>;
//   };
//
// ===========================================================================
xdr.struct("LedgerScpMessages", [
  ["ledgerSeq", xdr.lookup("Uint32")],
  ["messages", xdr.varArray(xdr.lookup("ScpEnvelope"), 2147483647)],
]);

// === xdr source ============================================================
//
//   struct SCPHistoryEntryV0
//   {
//       SCPQuorumSet quorumSets<>; // additional quorum sets used by ledgerMessages
//       LedgerSCPMessages ledgerMessages;
//   };
//
// ===========================================================================
xdr.struct("ScpHistoryEntryV0", [
  ["quorumSets", xdr.varArray(xdr.lookup("ScpQuorumSet"), 2147483647)],
  ["ledgerMessages", xdr.lookup("LedgerScpMessages")],
]);

// === xdr source ============================================================
//
//   union SCPHistoryEntry switch (LedgerVersion v)
//   {
//   case EMPTY_VERSION:
//       SCPHistoryEntryV0 v0;
//   };
//
// ===========================================================================
xdr.union("ScpHistoryEntry", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", "v0"],
  ],
  arms: {
    v0: xdr.lookup("ScpHistoryEntryV0"),
  },
});

// === xdr source ============================================================
//
//   enum LedgerEntryChangeType
//   {
//       LEDGER_ENTRY_CREATED = 0, // entry was added to the ledger
//       LEDGER_ENTRY_UPDATED = 1, // entry was modified in the ledger
//       LEDGER_ENTRY_REMOVED = 2, // entry was removed from the ledger
//       LEDGER_ENTRY_STATE = 3    // value of the entry
//   };
//
// ===========================================================================
xdr.enum("LedgerEntryChangeType", {
  ledgerEntryCreated: 0,
  ledgerEntryUpdated: 1,
  ledgerEntryRemoved: 2,
  ledgerEntryState: 3,
});

// === xdr source ============================================================
//
//   union LedgerEntryChange switch (LedgerEntryChangeType type)
//   {
//   case LEDGER_ENTRY_CREATED:
//       LedgerEntry created;
//   case LEDGER_ENTRY_UPDATED:
//       LedgerEntry updated;
//   case LEDGER_ENTRY_REMOVED:
//       LedgerKey removed;
//   case LEDGER_ENTRY_STATE:
//       LedgerEntry state;
//   };
//
// ===========================================================================
xdr.union("LedgerEntryChange", {
  switchOn: xdr.lookup("LedgerEntryChangeType"),
  switchName: "type",
  switches: [
    ["ledgerEntryCreated", "created"],
    ["ledgerEntryUpdated", "updated"],
    ["ledgerEntryRemoved", "removed"],
    ["ledgerEntryState", "state"],
  ],
  arms: {
    created: xdr.lookup("LedgerEntry"),
    updated: xdr.lookup("LedgerEntry"),
    removed: xdr.lookup("LedgerKey"),
    state: xdr.lookup("LedgerEntry"),
  },
});

// === xdr source ============================================================
//
//   typedef LedgerEntryChange LedgerEntryChanges<>;
//
// ===========================================================================
xdr.typedef("LedgerEntryChanges", xdr.varArray(xdr.lookup("LedgerEntryChange"), 2147483647));

// === xdr source ============================================================
//
//   struct OperationMeta
//   {
//       LedgerEntryChanges changes;
//   };
//
// ===========================================================================
xdr.struct("OperationMeta", [
  ["changes", xdr.lookup("LedgerEntryChanges")],
]);

// === xdr source ============================================================
//
//   union TransactionMeta switch (LedgerVersion v)
//   {
//   case EMPTY_VERSION:
//       OperationMeta operations<>;
//   };
//
// ===========================================================================
xdr.union("TransactionMeta", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", "operations"],
  ],
  arms: {
    operations: xdr.varArray(xdr.lookup("OperationMeta"), 2147483647),
  },
});

// === xdr source ============================================================
//
//   union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//
// ===========================================================================
xdr.union("CreatePassiveOfferOpExt", {
  switchOn: xdr.lookup("LedgerVersion"),
  switchName: "v",
  switches: [
    ["emptyVersion", xdr.void()],
  ],
  arms: {
  },
});

// === xdr source ============================================================
//
//   struct CreatePassiveOfferOp
//       {
//           Asset selling; // A
//           Asset buying;  // B
//           int64 amount;  // amount taker gets. if set to 0, delete the offer
//           Price price;   // cost of A in terms of B
//           union switch (LedgerVersion v)
//               {
//               case EMPTY_VERSION:
//                   void;
//               }
//               ext;
//       };
//
// ===========================================================================
xdr.struct("CreatePassiveOfferOp", [
  ["selling", xdr.lookup("Asset")],
  ["buying", xdr.lookup("Asset")],
  ["amount", xdr.lookup("Int64")],
  ["price", xdr.lookup("Price")],
  ["ext", xdr.lookup("CreatePassiveOfferOpExt")],
]);

});
export default types;
